//TODO : Refactor after ai
// Generiert von scripts/viacid-demo-data.py – nicht von Hand ändern.
// Quelle: Notion „Viacid Analyse“ → Datenmodell, Stand Review 12.10.2026.

import type { Datensatz } from "./types";

export const DATENSAETZE: Record<string, Datensatz[]> = {
  kunde: [
    {
      id: "k1",
      titel: "Gemeinde Wil",
      untertitel: "Kommune · 9500 Wil SG",
      kennung: "K-10021",
      status: null,
      werte: {
        kundennummer: "K-10021",
        name: "Gemeinde Wil",
        kundengruppe: "Kommune",
        adresse: "Marktgasse 58, 9500 Wil SG",
        eMailRechnungsversand: "rechnungen@gemeinde-wil.ch",
        zahlungsziel: 30,
        baustoffbezug: "Wettbewerb",
        bexioID: "4101",
      },
      bezuege: {
        "kunde-wird-betreut-von-mitarbeiter": "m1",
      },
    },
    {
      id: "k2",
      titel: "Stadt Frauenfeld",
      untertitel: "Kommune · 8500 Frauenfeld",
      kennung: "K-10022",
      status: null,
      werte: {
        kundennummer: "K-10022",
        name: "Stadt Frauenfeld",
        kundengruppe: "Kommune",
        adresse: "Schlossmühlestrasse 7, 8500 Frauenfeld",
        eMailRechnungsversand: "rechnungen@stadt-frauenfeld.ch",
        zahlungsziel: 30,
        baustoffbezug: "Viacid",
        bexioID: "4102",
      },
      bezuege: {
        "kunde-wird-betreut-von-mitarbeiter": "m1",
      },
    },
    {
      id: "k3",
      titel: "Gemeinde Uster",
      untertitel: "Kommune · 8610 Uster",
      kennung: "K-10023",
      status: null,
      werte: {
        kundennummer: "K-10023",
        name: "Gemeinde Uster",
        kundengruppe: "Kommune",
        adresse: "Bahnhofstrasse 17, 8610 Uster",
        eMailRechnungsversand: "rechnungen@gemeinde-uster.ch",
        zahlungsziel: 30,
        baustoffbezug: "unbekannt",
        bexioID: "4103",
      },
      bezuege: {
        "kunde-wird-betreut-von-mitarbeiter": "m2",
      },
    },
    {
      id: "k4",
      titel: "Stadt Sursee",
      untertitel: "Kommune · 6210 Sursee",
      kennung: "K-10024",
      status: null,
      werte: {
        kundennummer: "K-10024",
        name: "Stadt Sursee",
        kundengruppe: "Kommune",
        adresse: "Centralstrasse 9, 6210 Sursee",
        eMailRechnungsversand: "rechnungen@stadt-sursee.ch",
        zahlungsziel: 30,
        baustoffbezug: "Wettbewerb",
        bexioID: "4104",
      },
      bezuege: {
        "kunde-wird-betreut-von-mitarbeiter": "m1",
      },
    },
    {
      id: "k5",
      titel: "Strassenbau Meier AG",
      untertitel: "Bauunternehmen · 9200 Gossau SG",
      kennung: "K-10025",
      status: null,
      werte: {
        kundennummer: "K-10025",
        name: "Strassenbau Meier AG",
        kundengruppe: "Bauunternehmen",
        adresse: "Industriestrasse 21, 9200 Gossau SG",
        eMailRechnungsversand: "rechnungen@strassenbau-meier-ag.ch",
        zahlungsziel: 30,
        baustoffbezug: "Viacid",
        bexioID: "4105",
      },
      bezuege: {
        "kunde-wird-betreut-von-mitarbeiter": "m2",
      },
    },
    {
      id: "k6",
      titel: "Baustoffe Ostschweiz AG",
      untertitel: "Händler · 9000 St. Gallen",
      kennung: "K-10026",
      status: null,
      werte: {
        kundennummer: "K-10026",
        name: "Baustoffe Ostschweiz AG",
        kundengruppe: "Händler",
        adresse: "Rorschacher Strasse 140, 9000 St. Gallen",
        eMailRechnungsversand: "rechnungen@baustoffe-ostschweiz-ag.ch",
        zahlungsziel: 30,
        baustoffbezug: "Viacid",
        bexioID: "4106",
      },
      bezuege: {
        "kunde-wird-betreut-von-mitarbeiter": "m2",
      },
    },
    {
      id: "k7",
      titel: "Gemeinde Altdorf",
      untertitel: "Kommune · 6460 Altdorf UR",
      kennung: "K-10027",
      status: null,
      werte: {
        kundennummer: "K-10027",
        name: "Gemeinde Altdorf",
        kundengruppe: "Kommune",
        adresse: "Rathausplatz 1, 6460 Altdorf UR",
        eMailRechnungsversand: "rechnungen@gemeinde-altdorf.ch",
        zahlungsziel: 30,
        baustoffbezug: "unbekannt",
        bexioID: "4107",
      },
      bezuege: {
        "kunde-wird-betreut-von-mitarbeiter": "m1",
      },
    },
  ],
  mitarbeiter: [
    {
      id: "m1",
      titel: "Reto Brunner",
      untertitel: "Verkaufsberater",
      kennung: "P-101",
      status: null,
      werte: {
        name: "Reto Brunner",
        personalnummer: "P-101",
        funktion: "Verkaufsberater",
        qualifikationen: ["Akquise"],
        telefon: "+41 79 411 21 01",
        stundenkostensatz: 92,
      },
      bezuege: {},
    },
    {
      id: "m2",
      titel: "Sandra Keller",
      untertitel: "Leiterin Vertrieb",
      kennung: "P-102",
      status: null,
      werte: {
        name: "Sandra Keller",
        personalnummer: "P-102",
        funktion: "Leiterin Vertrieb",
        qualifikationen: ["Akquise", "Kalkulation"],
        telefon: "+41 79 412 22 02",
        stundenkostensatz: 110,
      },
      bezuege: {},
    },
    {
      id: "m3",
      titel: "Marco Frei",
      untertitel: "Disponent",
      kennung: "P-103",
      status: null,
      werte: {
        name: "Marco Frei",
        personalnummer: "P-103",
        funktion: "Disponent",
        qualifikationen: ["Kalkulation", "Disposition"],
        telefon: "+41 79 413 23 03",
        stundenkostensatz: 95,
      },
      bezuege: {},
    },
    {
      id: "m4",
      titel: "Luca Steiner",
      untertitel: "Gruppenführer",
      kennung: "P-104",
      status: null,
      werte: {
        name: "Luca Steiner",
        personalnummer: "P-104",
        funktion: "Gruppenführer",
        qualifikationen: [
          "Rissverguss",
          "Oberflächenbehandlung",
          "Spritzfahrzeug",
        ],
        telefon: "+41 79 414 24 04",
        stundenkostensatz: 88,
      },
      bezuege: {},
    },
    {
      id: "m5",
      titel: "Daniel Huber",
      untertitel: "Straßenunterhalt",
      kennung: "P-105",
      status: null,
      werte: {
        name: "Daniel Huber",
        personalnummer: "P-105",
        funktion: "Straßenunterhalt",
        qualifikationen: ["Rissverguss", "Walze"],
        telefon: "+41 79 415 25 05",
        stundenkostensatz: 78,
      },
      bezuege: {},
    },
    {
      id: "m6",
      titel: "Pascal Wyss",
      untertitel: "Straßenunterhalt",
      kennung: "P-106",
      status: null,
      werte: {
        name: "Pascal Wyss",
        personalnummer: "P-106",
        funktion: "Straßenunterhalt",
        qualifikationen: ["Rissverguss", "Kaltasphalt"],
        telefon: "+41 79 416 26 06",
        stundenkostensatz: 78,
      },
      bezuege: {},
    },
    {
      id: "m7",
      titel: "Nicole Baumann",
      untertitel: "Innendienst",
      kennung: "P-107",
      status: null,
      werte: {
        name: "Nicole Baumann",
        personalnummer: "P-107",
        funktion: "Innendienst",
        qualifikationen: ["Bexio", "Auftragsbearbeitung"],
        telefon: "+41 79 417 27 07",
        stundenkostensatz: 82,
      },
      bezuege: {},
    },
    {
      id: "m8",
      titel: "Thomas Gerber",
      untertitel: "Produktion",
      kennung: "P-108",
      status: null,
      werte: {
        name: "Thomas Gerber",
        personalnummer: "P-108",
        funktion: "Produktion",
        qualifikationen: ["Abfüllung", "Gabelstapler"],
        telefon: "+41 79 418 28 08",
        stundenkostensatz: 76,
      },
      bezuege: {},
    },
  ],
  strassenobjekt: [
    {
      id: "so1",
      titel: "Hauptstrasse Abschnitt Nord",
      untertitel: "Hauptstrasse, 9500 Wil SG",
      kennung: null,
      status: null,
      werte: {
        objektbezeichnung: "Hauptstrasse Abschnitt Nord",
        adresse: "Hauptstrasse, 9500 Wil SG",
        koordinaten: "47.4651, 9.0446",
        belagsart: "AC 11",
        zufahrtshinweise:
          "Halbseitige Sperrung mit Verkehrsdienst; Signalisation durch Viacid.",
      },
      bezuege: {
        "strassenobjekt-gehoert-zu-kunde": "k1",
      },
    },
    {
      id: "so2",
      titel: "Zürcherstrasse",
      untertitel: "Zürcherstrasse 90–180, 8500 Frauenfeld",
      kennung: null,
      status: null,
      werte: {
        objektbezeichnung: "Zürcherstrasse",
        adresse: "Zürcherstrasse 90–180, 8500 Frauenfeld",
        koordinaten: "47.5536, 8.8930",
        belagsart: "AC 11",
        zufahrtshinweise:
          "Halbseitige Sperrung mit Verkehrsdienst; Signalisation durch Viacid.",
      },
      bezuege: {
        "strassenobjekt-gehoert-zu-kunde": "k2",
      },
    },
    {
      id: "so3",
      titel: "Quartierstrassen Winikon",
      untertitel: "Winikon, 8610 Uster",
      kennung: null,
      status: null,
      werte: {
        objektbezeichnung: "Quartierstrassen Winikon",
        adresse: "Winikon, 8610 Uster",
        koordinaten: "47.3410, 8.7202",
        belagsart: "AC 8",
        zufahrtshinweise:
          "Halbseitige Sperrung mit Verkehrsdienst; Signalisation durch Viacid.",
      },
      bezuege: {
        "strassenobjekt-gehoert-zu-kunde": "k3",
      },
    },
    {
      id: "so4",
      titel: "Bahnhofstrasse",
      untertitel: "Bahnhofstrasse, 6210 Sursee",
      kennung: null,
      status: null,
      werte: {
        objektbezeichnung: "Bahnhofstrasse",
        adresse: "Bahnhofstrasse, 6210 Sursee",
        koordinaten: "47.1716, 8.1086",
        belagsart: "AC 11",
        zufahrtshinweise:
          "Halbseitige Sperrung mit Verkehrsdienst; Signalisation durch Viacid.",
      },
      bezuege: {
        "strassenobjekt-gehoert-zu-kunde": "k4",
      },
    },
    {
      id: "so5",
      titel: "Industriestrasse",
      untertitel: "Industriestrasse, 9500 Wil SG",
      kennung: null,
      status: null,
      werte: {
        objektbezeichnung: "Industriestrasse",
        adresse: "Industriestrasse, 9500 Wil SG",
        koordinaten: "47.4590, 9.0581",
        belagsart: "ACT 16",
        zufahrtshinweise:
          "Halbseitige Sperrung mit Verkehrsdienst; Signalisation durch Viacid.",
      },
      bezuege: {
        "strassenobjekt-gehoert-zu-kunde": "k1",
      },
    },
    {
      id: "so6",
      titel: "Klausenstrasse",
      untertitel: "Klausenstrasse, 6460 Altdorf UR",
      kennung: null,
      status: null,
      werte: {
        objektbezeichnung: "Klausenstrasse",
        adresse: "Klausenstrasse, 6460 Altdorf UR",
        koordinaten: "46.8806, 8.6444",
        belagsart: "AC 11",
        zufahrtshinweise:
          "Halbseitige Sperrung mit Verkehrsdienst; Signalisation durch Viacid.",
      },
      bezuege: {
        "strassenobjekt-gehoert-zu-kunde": "k7",
      },
    },
  ],
  baustellenaufnahme: [
    {
      id: "ba1",
      titel: "Aufnahme Hauptstrasse Abschnitt Nord",
      untertitel: "2026-10-05 · km 0.000–0.420",
      kennung: null,
      status: "Bewertet",
      werte: {
        aufnahmedatum: "2026-10-05",
        abschnitt: "km 0.000–0.420",
        gemesseneLaenge: 420,
        gemesseneBreite: 6.5,
        vorausmass: 2730.0,
        bewertetAm: "2026-10-05T16:30",
      },
      bezuege: {
        "baustellenaufnahme-betrifft-strassenobjekt": "so1",
        "baustellenaufnahme-erstellt-von-mitarbeiter": "m1",
        "baustellenaufnahme-fuer-verkaufschance": "vc1",
      },
    },
    {
      id: "ba2",
      titel: "Aufnahme Zürcherstrasse",
      untertitel: "2026-10-08 · Nr. 90–180, beidseitig",
      kennung: null,
      status: "Aufgenommen",
      werte: {
        aufnahmedatum: "2026-10-08",
        abschnitt: "Nr. 90–180, beidseitig",
        gemesseneLaenge: 680,
        gemesseneBreite: 7.0,
        vorausmass: 4760.0,
      },
      bezuege: {
        "baustellenaufnahme-betrifft-strassenobjekt": "so2",
        "baustellenaufnahme-erstellt-von-mitarbeiter": "m1",
        "baustellenaufnahme-fuer-verkaufschance": "vc2",
      },
    },
    {
      id: "ba3",
      titel: "Aufnahme Bahnhofstrasse",
      untertitel: "2026-10-12 · Bahnhofplatz bis Kreisel",
      kennung: null,
      status: "In Aufnahme",
      werte: {
        aufnahmedatum: "2026-10-12",
        abschnitt: "Bahnhofplatz bis Kreisel",
        gemesseneLaenge: 260,
        gemesseneBreite: 6.0,
      },
      bezuege: {
        "baustellenaufnahme-betrifft-strassenobjekt": "so4",
        "baustellenaufnahme-erstellt-von-mitarbeiter": "m1",
      },
    },
    {
      id: "ba4",
      titel: "Aufnahme Industriestrasse",
      untertitel: "2026-09-15 · ganze Länge",
      kennung: null,
      status: "Bewertet",
      werte: {
        aufnahmedatum: "2026-09-15",
        abschnitt: "ganze Länge",
        gemesseneLaenge: 380,
        gemesseneBreite: 7.5,
        vorausmass: 2850.0,
        bewertetAm: "2026-09-15T16:30",
      },
      bezuege: {
        "baustellenaufnahme-betrifft-strassenobjekt": "so5",
        "baustellenaufnahme-erstellt-von-mitarbeiter": "m4",
      },
    },
  ],
  schadstelle: [
    {
      id: "s1",
      titel: "Längsriss · Station 0+020 bis 0+105",
      untertitel: "85 lfm · Schweregrad mittel",
      kennung: null,
      status: null,
      werte: {
        position: "Station 0+020 bis 0+105",
        schadensart: "Längsriss",
        schadensmenge: 85,
        mengeneinheit: "lfm",
        schweregrad: "mittel",
        beschreibung:
          "Durchgehender Längsriss in der Fahrbahnmitte, Breite 5–8 mm.",
        geschaetzteMaterialmenge: 38.2,
      },
      bezuege: {
        "schadstelle-gehoert-zu-baustellenaufnahme": "ba1",
        "schadstelle-erfordert-massnahmenart": "ma1",
        "schadstelle-empfiehlt-artikel": ["ar1"],
      },
    },
    {
      id: "s2",
      titel: "Netzrisse · Station 0+140",
      untertitel: "120 lfm · Schweregrad mittel",
      kennung: null,
      status: null,
      werte: {
        position: "Station 0+140",
        schadensart: "Netzrisse",
        schadensmenge: 120,
        mengeneinheit: "lfm",
        schweregrad: "mittel",
        beschreibung: "Netzrisse im Bereich der Bushaltestelle.",
        geschaetzteMaterialmenge: 54.0,
      },
      bezuege: {
        "schadstelle-gehoert-zu-baustellenaufnahme": "ba1",
        "schadstelle-erfordert-massnahmenart": "ma1",
        "schadstelle-empfiehlt-artikel": ["ar1"],
      },
    },
    {
      id: "s3",
      titel: "Schlagloch · Station 0+210",
      untertitel: "3 m² · Schweregrad hoch",
      kennung: null,
      status: null,
      werte: {
        position: "Station 0+210",
        schadensart: "Schlagloch",
        schadensmenge: 3,
        mengeneinheit: "m²",
        schweregrad: "hoch",
        beschreibung:
          "Drei Schlaglöcher, Tiefe bis 6 cm, Unfallgefahr für Velofahrende.",
        geschaetzteMaterialmenge: 90,
      },
      bezuege: {
        "schadstelle-gehoert-zu-baustellenaufnahme": "ba1",
        "schadstelle-erfordert-massnahmenart": "ma2",
        "schadstelle-empfiehlt-artikel": ["ar2"],
      },
    },
    {
      id: "s4",
      titel: "Querriss · Station 0+390",
      untertitel: "32 lfm · Schweregrad gering",
      kennung: null,
      status: null,
      werte: {
        position: "Station 0+390",
        schadensart: "Querriss",
        schadensmenge: 32,
        mengeneinheit: "lfm",
        schweregrad: "gering",
        beschreibung: "Querriss über die ganze Breite.",
        geschaetzteMaterialmenge: 14.4,
      },
      bezuege: {
        "schadstelle-gehoert-zu-baustellenaufnahme": "ba1",
        "schadstelle-erfordert-massnahmenart": "ma1",
        "schadstelle-empfiehlt-artikel": ["ar1"],
      },
    },
    {
      id: "s5",
      titel: "Randsteinfuge offen · Einmündung Bahnhofplatz",
      untertitel: "64 lfm · Schweregrad mittel",
      kennung: null,
      status: null,
      werte: {
        position: "Einmündung Bahnhofplatz",
        schadensart: "Randsteinfuge offen",
        schadensmenge: 64,
        mengeneinheit: "lfm",
        schweregrad: "mittel",
        beschreibung:
          "Fuge zwischen Belag und Randstein bis 15 mm offen, Wassereintritt.",
        geschaetzteMaterialmenge: 57.6,
      },
      bezuege: {
        "schadstelle-gehoert-zu-baustellenaufnahme": "ba2",
        "schadstelle-erfordert-massnahmenart": "ma3",
        "schadstelle-empfiehlt-artikel": ["ar6"],
      },
    },
    {
      id: "s6",
      titel: "Schlagloch · Höhe Nr. 112",
      untertitel: "1.5 m² · Schweregrad hoch",
      kennung: null,
      status: null,
      werte: {
        position: "Höhe Nr. 112",
        schadensart: "Schlagloch",
        schadensmenge: 1.5,
        mengeneinheit: "m²",
        schweregrad: "hoch",
        beschreibung: "Schlagloch im Rad-Streifen.",
        geschaetzteMaterialmenge: 45.0,
      },
      bezuege: {
        "schadstelle-gehoert-zu-baustellenaufnahme": "ba2",
        "schadstelle-erfordert-massnahmenart": "ma2",
        "schadstelle-empfiehlt-artikel": ["ar2"],
      },
    },
    {
      id: "s7",
      titel: "Randsteinfuge offen · Nr. 140–180",
      untertitel: "146 lfm · Schweregrad gering",
      kennung: null,
      status: null,
      werte: {
        position: "Nr. 140–180",
        schadensart: "Randsteinfuge offen",
        schadensmenge: 146,
        mengeneinheit: "lfm",
        schweregrad: "gering",
        beschreibung: "Fuge teilweise bewachsen.",
        geschaetzteMaterialmenge: 131.4,
      },
      bezuege: {
        "schadstelle-gehoert-zu-baustellenaufnahme": "ba2",
        "schadstelle-erfordert-massnahmenart": "ma3",
        "schadstelle-empfiehlt-artikel": ["ar6"],
      },
    },
    {
      id: "s8",
      titel: "Längsriss · ganze Länge",
      untertitel: "140 lfm · Schweregrad mittel",
      kennung: null,
      status: null,
      werte: {
        position: "ganze Länge",
        schadensart: "Längsriss",
        schadensmenge: 140,
        mengeneinheit: "lfm",
        schweregrad: "mittel",
        beschreibung: "Längsriss in der Rollspur.",
        geschaetzteMaterialmenge: 63.0,
      },
      bezuege: {
        "schadstelle-gehoert-zu-baustellenaufnahme": "ba4",
        "schadstelle-erfordert-massnahmenart": "ma1",
        "schadstelle-empfiehlt-artikel": ["ar1"],
      },
    },
  ],
  baustellenfoto: [
    {
      id: "bf1",
      titel: "Längsriss Station 0+050",
      untertitel: "Schaden · 2026-10-05 09:12",
      kennung: null,
      status: null,
      werte: {
        datei: "IMG_4102.jpg",
        fotoart: "Schaden",
        aufnahmezeitpunkt: "2026-10-05T09:12",
        beschreibung: "Längsriss Station 0+050",
      },
      bezuege: {
        "baustellenfoto-gehoert-zu-baustellenaufnahme": "ba1",
        "baustellenfoto-zeigt-schadstelle": "s1",
      },
    },
    {
      id: "bf2",
      titel: "Schlaglöcher Station 0+210",
      untertitel: "Schaden · 2026-10-05 09:31",
      kennung: null,
      status: null,
      werte: {
        datei: "IMG_4108.jpg",
        fotoart: "Schaden",
        aufnahmezeitpunkt: "2026-10-05T09:31",
        beschreibung: "Schlaglöcher Station 0+210",
      },
      bezuege: {
        "baustellenfoto-gehoert-zu-baustellenaufnahme": "ba1",
        "baustellenfoto-zeigt-schadstelle": "s3",
      },
    },
    {
      id: "bf3",
      titel: "Offene Fuge Einmündung Bahnhofplatz",
      untertitel: "Schaden · 2026-10-08 14:05",
      kennung: null,
      status: null,
      werte: {
        datei: "IMG_4177.jpg",
        fotoart: "Schaden",
        aufnahmezeitpunkt: "2026-10-08T14:05",
        beschreibung: "Offene Fuge Einmündung Bahnhofplatz",
      },
      bezuege: {
        "baustellenfoto-gehoert-zu-baustellenaufnahme": "ba2",
        "baustellenfoto-zeigt-schadstelle": "s5",
      },
    },
    {
      id: "bf4",
      titel: "Industriestrasse vor dem Rissverguss",
      untertitel: "Vorher · 2026-10-06 07:40",
      kennung: null,
      status: null,
      werte: {
        datei: "IMG_4231.jpg",
        fotoart: "Vorher",
        aufnahmezeitpunkt: "2026-10-06T07:40",
        beschreibung: "Industriestrasse vor dem Rissverguss",
      },
      bezuege: {
        "baustellenfoto-dokumentiert-einsatz": "e1",
      },
    },
    {
      id: "bf5",
      titel: "Industriestrasse nach dem Rissverguss",
      untertitel: "Nachher · 2026-10-06 11:20",
      kennung: null,
      status: null,
      werte: {
        datei: "IMG_4249.jpg",
        fotoart: "Nachher",
        aufnahmezeitpunkt: "2026-10-06T11:20",
        beschreibung: "Industriestrasse nach dem Rissverguss",
      },
      bezuege: {
        "baustellenfoto-dokumentiert-einsatz": "e1",
        "baustellenfoto-belegt-ausmassposition": ["amp1"],
      },
    },
    {
      id: "bf6",
      titel: "Fuge bei Nr. 140 wieder offen",
      untertitel: "Mangel · 2026-10-08 10:02",
      kennung: null,
      status: null,
      werte: {
        datei: "IMG_4302.jpg",
        fotoart: "Mangel",
        aufnahmezeitpunkt: "2026-10-08T10:02",
        beschreibung: "Fuge bei Nr. 140 wieder offen",
      },
      bezuege: {
        "baustellenfoto-belegt-reklamation": "rk1",
      },
    },
  ],
  massnahmenart: [
    {
      id: "ma1",
      titel: "Rissverguss",
      untertitel: "je lfm · Winter (Okt–Mär)",
      kennung: null,
      status: null,
      werte: {
        bezeichnung: "Rissverguss",
        beschreibung:
          "Risse reinigen, mit Heissluft trocknen und mit Vergussmasse schliessen.",
        abrechnungseinheit: "lfm",
        saisonfenster: ["Winter (Okt–Mär)"],
        einheitspreis: 6.8,
        bindemittelansatz: 0.45,
        splittansatz: 0,
        leistungJeStunde: 120,
        teamgroesse: 3,
        mindesttemperaturBoden: 5,
        ausfuehrungsbedingungen:
          "Bodentemperatur mindestens 5 °C, Oberfläche trocken und sauber.",
      },
      bezuege: {},
    },
    {
      id: "ma2",
      titel: "Schlaglochreparatur Kaltasphalt",
      untertitel: "je m² · Winter (Okt–Mär)",
      kennung: null,
      status: null,
      werte: {
        bezeichnung: "Schlaglochreparatur Kaltasphalt",
        beschreibung:
          "Schlagloch ausräumen und mit Kaltasphalt verdichten; auch bei Kälte möglich.",
        abrechnungseinheit: "m²",
        saisonfenster: ["Winter (Okt–Mär)"],
        einheitspreis: 85.0,
        bindemittelansatz: 0,
        splittansatz: 0,
        leistungJeStunde: 6,
        teamgroesse: 2,
        mindesttemperaturBoden: -5,
        ausfuehrungsbedingungen:
          "Bodentemperatur mindestens -5 °C, Oberfläche trocken und sauber.",
      },
      bezuege: {},
    },
    {
      id: "ma3",
      titel: "Randsteinfugensanierung",
      untertitel: "je lfm · Frühjahr (Apr–Mai)",
      kennung: null,
      status: null,
      werte: {
        bezeichnung: "Randsteinfugensanierung",
        beschreibung:
          "Offene Fugen zwischen Belag und Randstein ausfräsen und vergiessen.",
        abrechnungseinheit: "lfm",
        saisonfenster: ["Frühjahr (Apr–Mai)"],
        einheitspreis: 14.5,
        bindemittelansatz: 0.9,
        splittansatz: 0,
        leistungJeStunde: 60,
        teamgroesse: 3,
        mindesttemperaturBoden: 5,
        ausfuehrungsbedingungen:
          "Bodentemperatur mindestens 5 °C, Oberfläche trocken und sauber.",
      },
      bezuege: {},
    },
    {
      id: "ma4",
      titel: "Oberflächenbehandlung einfach",
      untertitel: "je m² · Sommer (Jun–Sep)",
      kennung: null,
      status: null,
      werte: {
        bezeichnung: "Oberflächenbehandlung einfach",
        beschreibung: "Bindemittel spritzen, Edelsplitt streuen, walzen.",
        abrechnungseinheit: "m²",
        saisonfenster: ["Sommer (Jun–Sep)"],
        einheitspreis: 9.8,
        bindemittelansatz: 1.5,
        splittansatz: 12,
        leistungJeStunde: 400,
        teamgroesse: 5,
        mindesttemperaturBoden: 15,
        ausfuehrungsbedingungen:
          "Bodentemperatur mindestens 15 °C, Oberfläche trocken und sauber.",
      },
      bezuege: {},
    },
    {
      id: "ma5",
      titel: "Oberflächenbehandlung doppelt",
      untertitel: "je m² · Sommer (Jun–Sep)",
      kennung: null,
      status: null,
      werte: {
        bezeichnung: "Oberflächenbehandlung doppelt",
        beschreibung:
          "Zweilagige Oberflächenbehandlung für stärker beanspruchte Strassen.",
        abrechnungseinheit: "m²",
        saisonfenster: ["Sommer (Jun–Sep)"],
        einheitspreis: 14.2,
        bindemittelansatz: 2.4,
        splittansatz: 20,
        leistungJeStunde: 300,
        teamgroesse: 5,
        mindesttemperaturBoden: 15,
        ausfuehrungsbedingungen:
          "Bodentemperatur mindestens 15 °C, Oberfläche trocken und sauber.",
      },
      bezuege: {},
    },
  ],
  artikel: [
    {
      id: "ar1",
      titel: "Rissvergussmasse heiss 25 kg",
      untertitel: "Vergussmassen · Eimer 25 kg",
      kennung: "VIA-2010",
      status: "Aktiv",
      werte: {
        artikelnummer: "VIA-2010",
        bezeichnung: "Rissvergussmasse heiss",
        artikelgruppe: "Vergussmassen",
        gebindeeinheit: "Eimer",
        gebindegroesse: 25,
        mengeneinheit: "kg",
        verkaufspreis: 118.0,
        einstandspreis: 71.0,
        preisGueltigAb: "2026-01-01",
      },
      bezuege: {},
    },
    {
      id: "ar2",
      titel: "Kaltasphalt 0/8 30 kg",
      untertitel: "Kaltmischgut · Eimer 30 kg",
      kennung: "VIA-2040",
      status: "Aktiv",
      werte: {
        artikelnummer: "VIA-2040",
        bezeichnung: "Kaltasphalt 0/8",
        artikelgruppe: "Kaltmischgut",
        gebindeeinheit: "Eimer",
        gebindegroesse: 30,
        mengeneinheit: "kg",
        verkaufspreis: 64.0,
        einstandspreis: 36.5,
        preisGueltigAb: "2026-01-01",
      },
      bezuege: {},
    },
    {
      id: "ar3",
      titel: "Kaltasphalt 0/8 1000 kg",
      untertitel: "Kaltmischgut · Big Bag 1000 kg",
      kennung: "VIA-2041",
      status: "Aktiv",
      werte: {
        artikelnummer: "VIA-2041",
        bezeichnung: "Kaltasphalt 0/8",
        artikelgruppe: "Kaltmischgut",
        gebindeeinheit: "Big Bag",
        gebindegroesse: 1000,
        mengeneinheit: "kg",
        verkaufspreis: 1180.0,
        einstandspreis: 690.0,
        preisGueltigAb: "2026-01-01",
      },
      bezuege: {},
    },
    {
      id: "ar4",
      titel: "Bitumenemulsion C69B4 1000 l",
      untertitel: "Bindemittel · IBC 1000 l",
      kennung: "VIA-3100",
      status: "Aktiv",
      werte: {
        artikelnummer: "VIA-3100",
        bezeichnung: "Bitumenemulsion C69B4",
        artikelgruppe: "Bindemittel",
        gebindeeinheit: "IBC",
        gebindegroesse: 1000,
        mengeneinheit: "l",
        verkaufspreis: 1450.0,
        einstandspreis: 905.0,
        preisGueltigAb: "2026-01-01",
      },
      bezuege: {},
    },
    {
      id: "ar5",
      titel: "Edelsplitt 4/8 1000 kg",
      untertitel: "Splitt · Big Bag 1000 kg",
      kennung: "VIA-4020",
      status: "Aktiv",
      werte: {
        artikelnummer: "VIA-4020",
        bezeichnung: "Edelsplitt 4/8",
        artikelgruppe: "Splitt",
        gebindeeinheit: "Big Bag",
        gebindegroesse: 1000,
        mengeneinheit: "kg",
        verkaufspreis: 165.0,
        einstandspreis: 98.0,
        preisGueltigAb: "2026-01-01",
      },
      bezuege: {},
    },
    {
      id: "ar6",
      titel: "Fugenvergussmasse kalt 20 kg",
      untertitel: "Vergussmassen · Eimer 20 kg",
      kennung: "VIA-2015",
      status: "Aktiv",
      werte: {
        artikelnummer: "VIA-2015",
        bezeichnung: "Fugenvergussmasse kalt",
        artikelgruppe: "Vergussmassen",
        gebindeeinheit: "Eimer",
        gebindegroesse: 20,
        mengeneinheit: "kg",
        verkaufspreis: 96.0,
        einstandspreis: 55.0,
        preisGueltigAb: "2026-01-01",
      },
      bezuege: {},
    },
    {
      id: "ar7",
      titel: "Haftvermittler Primer 10 l",
      untertitel: "Zubehör · Kanister 10 l",
      kennung: "VIA-5001",
      status: "Aktiv",
      werte: {
        artikelnummer: "VIA-5001",
        bezeichnung: "Haftvermittler Primer",
        artikelgruppe: "Zubehör",
        gebindeeinheit: "Kanister",
        gebindegroesse: 10,
        mengeneinheit: "l",
        verkaufspreis: 74.0,
        einstandspreis: 39.0,
        preisGueltigAb: "2026-01-01",
      },
      bezuege: {},
    },
    {
      id: "ar8",
      titel: "Rissvergussmasse alt (Rezeptur 2019) 25 kg",
      untertitel: "Vergussmassen · Eimer 25 kg",
      kennung: "VIA-2005",
      status: "Ausgelistet",
      werte: {
        artikelnummer: "VIA-2005",
        bezeichnung: "Rissvergussmasse alt (Rezeptur 2019)",
        artikelgruppe: "Vergussmassen",
        gebindeeinheit: "Eimer",
        gebindegroesse: 25,
        mengeneinheit: "kg",
        verkaufspreis: 109.0,
        einstandspreis: 68.0,
        preisGueltigAb: "2026-01-01",
      },
      bezuege: {},
    },
  ],
  kalkulation: [
    {
      id: "kal1",
      titel: "Rissverguss · Version 1",
      untertitel: "237 lfm · Fr. 1'611.60",
      kennung: null,
      status: "Freigegeben",
      werte: {
        kalkulationsdatum: "2026-10-06",
        version: 1,
        kalkulierteFlaeche: 237,
        bindemittelansatz: 0.45,
        splittansatz: 0,
        anzahlMitarbeitende: 3,
        benoetigteFahrzeugarten: ["Spezialfahrzeug", "Lieferwagen"],
        ausfuehrungsdauer: 2.0,
        kalkulierterPreis: 1611.6,
        annahmen:
          "Beispielwerte für Ansatz und Leistung – Kalkulationsparameter von Viacid noch offen.",
        freigegebenAm: "2026-10-06T17:00",
      },
      bezuege: {
        "kalkulation-basiert-auf-baustellenaufnahme": "ba1",
        "kalkulation-fuer-verkaufschance": "vc1",
        "kalkulation-fuer-massnahmenart": "ma1",
      },
    },
    {
      id: "kal2",
      titel: "Schlaglochreparatur Kaltasphalt · Version 1",
      untertitel: "3 m² · Fr. 255.00",
      kennung: null,
      status: "Freigegeben",
      werte: {
        kalkulationsdatum: "2026-10-06",
        version: 1,
        kalkulierteFlaeche: 3,
        bindemittelansatz: 0,
        splittansatz: 0,
        anzahlMitarbeitende: 2,
        benoetigteFahrzeugarten: ["Lieferwagen"],
        ausfuehrungsdauer: 0.5,
        kalkulierterPreis: 255.0,
        annahmen:
          "Beispielwerte für Ansatz und Leistung – Kalkulationsparameter von Viacid noch offen.",
        freigegebenAm: "2026-10-06T17:00",
      },
      bezuege: {
        "kalkulation-basiert-auf-baustellenaufnahme": "ba1",
        "kalkulation-fuer-verkaufschance": "vc1",
        "kalkulation-fuer-massnahmenart": "ma2",
      },
    },
    {
      id: "kal3",
      titel: "Randsteinfugensanierung · Version 1",
      untertitel: "210 lfm · Fr. 3'045.00",
      kennung: null,
      status: "Entwurf",
      werte: {
        kalkulationsdatum: "2026-10-06",
        version: 1,
        kalkulierteFlaeche: 210,
        bindemittelansatz: 0.9,
        splittansatz: 0,
        anzahlMitarbeitende: 3,
        benoetigteFahrzeugarten: ["Spezialfahrzeug", "Lieferwagen"],
        ausfuehrungsdauer: 3.5,
        kalkulierterPreis: 3045.0,
        annahmen:
          "Beispielwerte für Ansatz und Leistung – Kalkulationsparameter von Viacid noch offen.",
      },
      bezuege: {
        "kalkulation-basiert-auf-baustellenaufnahme": "ba2",
        "kalkulation-fuer-verkaufschance": "vc2",
        "kalkulation-fuer-massnahmenart": "ma3",
      },
    },
    {
      id: "kal4",
      titel: "Rissverguss · Version 1",
      untertitel: "130 lfm · Fr. 884.00",
      kennung: null,
      status: "Überholt",
      werte: {
        kalkulationsdatum: "2026-09-16",
        version: 1,
        kalkulierteFlaeche: 130,
        bindemittelansatz: 0.45,
        splittansatz: 0,
        anzahlMitarbeitende: 3,
        benoetigteFahrzeugarten: ["Spezialfahrzeug"],
        ausfuehrungsdauer: 1.1,
        kalkulierterPreis: 884.0,
        annahmen:
          "Beispielwerte für Ansatz und Leistung – Kalkulationsparameter von Viacid noch offen.",
        freigegebenAm: "2026-09-16T17:00",
      },
      bezuege: {
        "kalkulation-basiert-auf-baustellenaufnahme": "ba4",
        "kalkulation-fuer-auftrag": "au1",
        "kalkulation-fuer-massnahmenart": "ma1",
      },
    },
    {
      id: "kal5",
      titel: "Rissverguss · Version 2",
      untertitel: "140 lfm · Fr. 952.00",
      kennung: null,
      status: "Freigegeben",
      werte: {
        kalkulationsdatum: "2026-09-16",
        version: 2,
        kalkulierteFlaeche: 140,
        bindemittelansatz: 0.45,
        splittansatz: 0,
        anzahlMitarbeitende: 3,
        benoetigteFahrzeugarten: ["Spezialfahrzeug", "Lieferwagen"],
        ausfuehrungsdauer: 1.2,
        kalkulierterPreis: 952.0,
        annahmen:
          "Beispielwerte für Ansatz und Leistung – Kalkulationsparameter von Viacid noch offen.",
        freigegebenAm: "2026-09-16T17:00",
      },
      bezuege: {
        "kalkulation-basiert-auf-baustellenaufnahme": "ba4",
        "kalkulation-fuer-auftrag": "au1",
        "kalkulation-fuer-massnahmenart": "ma1",
        "kalkulation-ersetzt-kalkulation": "kal4",
      },
    },
  ],
  kalkulationsposition: [
    {
      id: "kp1",
      titel: "Rissvergussmasse heiss",
      untertitel: "Material · 107 kg",
      kennung: null,
      status: null,
      werte: {
        positionsart: "Material",
        bezeichnung: "Rissvergussmasse heiss",
        menge: 107,
        einheit: "kg",
        kostensatz: 2.84,
      },
      bezuege: {
        "kalkulationsposition-gehoert-zu-kalkulation": "kal1",
        "kalkulationsposition-verwendet-artikel": "ar1",
      },
    },
    {
      id: "kp2",
      titel: "Gruppenführer",
      untertitel: "Personal · 2.0 h",
      kennung: null,
      status: null,
      werte: {
        positionsart: "Personal",
        bezeichnung: "Gruppenführer",
        menge: 2.0,
        einheit: "h",
        kostensatz: 88,
      },
      bezuege: {
        "kalkulationsposition-gehoert-zu-kalkulation": "kal1",
      },
    },
    {
      id: "kp3",
      titel: "Strassenunterhalt (2 Personen)",
      untertitel: "Personal · 4.0 h",
      kennung: null,
      status: null,
      werte: {
        positionsart: "Personal",
        bezeichnung: "Strassenunterhalt (2 Personen)",
        menge: 4.0,
        einheit: "h",
        kostensatz: 78,
      },
      bezuege: {
        "kalkulationsposition-gehoert-zu-kalkulation": "kal1",
      },
    },
    {
      id: "kp4",
      titel: "Spritzfahrzeug Rissverguss",
      untertitel: "Fahrzeug · 2.0 h",
      kennung: null,
      status: null,
      werte: {
        positionsart: "Fahrzeug",
        bezeichnung: "Spritzfahrzeug Rissverguss",
        menge: 2.0,
        einheit: "h",
        kostensatz: 145,
      },
      bezuege: {
        "kalkulationsposition-gehoert-zu-kalkulation": "kal1",
      },
    },
    {
      id: "kp5",
      titel: "Kaltasphalt 0/8",
      untertitel: "Material · 90 kg",
      kennung: null,
      status: null,
      werte: {
        positionsart: "Material",
        bezeichnung: "Kaltasphalt 0/8",
        menge: 90,
        einheit: "kg",
        kostensatz: 1.22,
      },
      bezuege: {
        "kalkulationsposition-gehoert-zu-kalkulation": "kal2",
        "kalkulationsposition-verwendet-artikel": "ar2",
      },
    },
    {
      id: "kp6",
      titel: "Strassenunterhalt (2 Personen)",
      untertitel: "Personal · 1.0 h",
      kennung: null,
      status: null,
      werte: {
        positionsart: "Personal",
        bezeichnung: "Strassenunterhalt (2 Personen)",
        menge: 1.0,
        einheit: "h",
        kostensatz: 78,
      },
      bezuege: {
        "kalkulationsposition-gehoert-zu-kalkulation": "kal2",
      },
    },
    {
      id: "kp7",
      titel: "Fugenvergussmasse kalt",
      untertitel: "Material · 189 kg",
      kennung: null,
      status: null,
      werte: {
        positionsart: "Material",
        bezeichnung: "Fugenvergussmasse kalt",
        menge: 189,
        einheit: "kg",
        kostensatz: 2.75,
      },
      bezuege: {
        "kalkulationsposition-gehoert-zu-kalkulation": "kal3",
        "kalkulationsposition-verwendet-artikel": "ar6",
      },
    },
    {
      id: "kp8",
      titel: "Gruppenführer + 2 Personen",
      untertitel: "Personal · 10.5 h",
      kennung: null,
      status: null,
      werte: {
        positionsart: "Personal",
        bezeichnung: "Gruppenführer + 2 Personen",
        menge: 10.5,
        einheit: "h",
        kostensatz: 81,
      },
      bezuege: {
        "kalkulationsposition-gehoert-zu-kalkulation": "kal3",
      },
    },
    {
      id: "kp9",
      titel: "Rissvergussmasse heiss",
      untertitel: "Material · 63 kg",
      kennung: null,
      status: null,
      werte: {
        positionsart: "Material",
        bezeichnung: "Rissvergussmasse heiss",
        menge: 63,
        einheit: "kg",
        kostensatz: 2.84,
      },
      bezuege: {
        "kalkulationsposition-gehoert-zu-kalkulation": "kal5",
        "kalkulationsposition-verwendet-artikel": "ar1",
      },
    },
    {
      id: "kp10",
      titel: "Spritzfahrzeug Rissverguss",
      untertitel: "Fahrzeug · 1.2 h",
      kennung: null,
      status: null,
      werte: {
        positionsart: "Fahrzeug",
        bezeichnung: "Spritzfahrzeug Rissverguss",
        menge: 1.2,
        einheit: "h",
        kostensatz: 145,
      },
      bezuege: {
        "kalkulationsposition-gehoert-zu-kalkulation": "kal5",
      },
    },
  ],
  angebot: [
    {
      id: "an1",
      titel: "Rissverguss und Schlaglöcher Hauptstrasse Nord",
      untertitel: "Gemeinde Wil · 2026-10-12",
      kennung: "AN-2026-0412",
      status: "In Erstellung",
      werte: {
        angebotsnummer: "AN-2026-0412",
        dokumentart: "Angebot",
        angebotsdatum: "2026-10-12",
        gueltigBis: "2026-11-11",
        version: 1,
        leistungsbeschreibung:
          "Rissverguss und Schlaglochreparatur Hauptstrasse Nord, inkl. Signalisation.",
      },
      bezuege: {
        "angebot-an-kunde": "k1",
        "angebot-an-ansprechpartner": "a1",
        "angebot-erstellt-von-mitarbeiter": "m1",
        "angebot-zu-verkaufschance": "vc1",
        "angebot-basiert-auf-kalkulation": ["kal1", "kal2"],
        "angebot-betrifft-strassenobjekt": ["so1"],
      },
    },
    {
      id: "an2",
      titel: "Auftragsbestätigung Baustoffe Ostschweiz AG",
      untertitel: "Baustoffe Ostschweiz AG · 2026-10-02",
      kennung: "AB-2026-0398",
      status: "Angenommen",
      werte: {
        angebotsnummer: "AB-2026-0398",
        dokumentart: "Auftragsbestätigung",
        angebotsdatum: "2026-10-02",
        version: 1,
        versendetAm: "2026-10-02T15:40",
        entschiedenAm: "2026-10-03T08:10",
      },
      bezuege: {
        "angebot-an-kunde": "k6",
        "angebot-an-ansprechpartner": "a6",
        "angebot-erstellt-von-mitarbeiter": "m7",
        "angebot-zu-bestellung": "bs1",
      },
    },
    {
      id: "an3",
      titel: "Kaltasphalt Winterdienst",
      untertitel: "Stadt Sursee · 2026-09-30",
      kennung: "AN-2026-0377",
      status: "Versendet",
      werte: {
        angebotsnummer: "AN-2026-0377",
        dokumentart: "Angebot",
        angebotsdatum: "2026-09-30",
        gueltigBis: "2026-10-30",
        version: 1,
        versendetAm: "2026-09-30T16:05",
        leistungsbeschreibung: "Lieferung Kaltasphalt für den Winterdienst.",
      },
      bezuege: {
        "angebot-an-kunde": "k4",
        "angebot-an-ansprechpartner": "a4",
        "angebot-erstellt-von-mitarbeiter": "m1",
        "angebot-zu-verkaufschance": "vc3",
      },
    },
    {
      id: "an4",
      titel: "Angebot Gemeinde Uster",
      untertitel: "Gemeinde Uster · 2026-09-24",
      kennung: "AN-2026-0350",
      status: "Änderung gewünscht",
      werte: {
        angebotsnummer: "AN-2026-0350",
        dokumentart: "Angebot",
        angebotsdatum: "2026-09-24",
        gueltigBis: "2026-10-24",
        version: 1,
        versendetAm: "2026-09-24T11:00",
        aenderungswunsch:
          "Oberer Abschnitt als doppelte Oberflächenbehandlung anbieten.",
      },
      bezuege: {
        "angebot-an-kunde": "k3",
        "angebot-an-ansprechpartner": "a3",
        "angebot-erstellt-von-mitarbeiter": "m2",
        "angebot-zu-verkaufschance": "vc4",
        "angebot-betrifft-strassenobjekt": ["so3"],
      },
    },
    {
      id: "an5",
      titel: "Angebot Gemeinde Wil",
      untertitel: "Gemeinde Wil · 2026-09-16",
      kennung: "AN-2026-0331",
      status: "Angenommen",
      werte: {
        angebotsnummer: "AN-2026-0331",
        dokumentart: "Angebot",
        angebotsdatum: "2026-09-16",
        gueltigBis: "2026-10-16",
        version: 1,
        versendetAm: "2026-09-16T17:20",
        entschiedenAm: "2026-09-19T09:30",
      },
      bezuege: {
        "angebot-an-kunde": "k1",
        "angebot-an-ansprechpartner": "a1",
        "angebot-erstellt-von-mitarbeiter": "m1",
        "angebot-basiert-auf-kalkulation": ["kal5"],
        "angebot-betrifft-strassenobjekt": ["so5"],
      },
    },
    {
      id: "an6",
      titel: "Angebot Gemeinde Altdorf",
      untertitel: "Gemeinde Altdorf · 2026-09-08",
      kennung: "AN-2026-0302",
      status: "Abgelehnt",
      werte: {
        angebotsnummer: "AN-2026-0302",
        dokumentart: "Angebot",
        angebotsdatum: "2026-09-08",
        gueltigBis: "2026-10-08",
        version: 1,
        versendetAm: "2026-09-08T14:00",
        entschiedenAm: "2026-09-28T10:15",
        ablehnungsgrund: "Mitbewerber günstiger.",
      },
      bezuege: {
        "angebot-an-kunde": "k7",
        "angebot-an-ansprechpartner": "a7",
        "angebot-erstellt-von-mitarbeiter": "m1",
        "angebot-zu-verkaufschance": "vc6",
        "angebot-betrifft-strassenobjekt": ["so6"],
      },
    },
  ],
  angebotsposition: [
    {
      id: "anp1",
      titel: "Rissverguss",
      untertitel: "237 lfm à Fr. 6.80",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 1,
        bezeichnung: "Rissverguss",
        menge: 237,
        einheit: "lfm",
        einzelpreis: 6.8,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an1",
        "angebotsposition-bietet-an-massnahmenart": "ma1",
      },
    },
    {
      id: "anp2",
      titel: "Schlaglochreparatur Kaltasphalt",
      untertitel: "3 m² à Fr. 85.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 2,
        bezeichnung: "Schlaglochreparatur Kaltasphalt",
        menge: 3,
        einheit: "m²",
        einzelpreis: 85.0,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an1",
        "angebotsposition-bietet-an-massnahmenart": "ma2",
      },
    },
    {
      id: "anp3",
      titel: "Signalisation und Verkehrsdienst",
      untertitel: "1 pauschal à Fr. 380.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 3,
        bezeichnung: "Signalisation und Verkehrsdienst",
        menge: 1,
        einheit: "pauschal",
        einzelpreis: 380.0,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an1",
      },
    },
    {
      id: "anp4",
      titel: "Kaltasphalt 0/8, Big Bag 1000 kg",
      untertitel: "4 Stk à Fr. 1180.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 1,
        bezeichnung: "Kaltasphalt 0/8, Big Bag 1000 kg",
        menge: 4,
        einheit: "Stk",
        einzelpreis: 1180.0,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an3",
        "angebotsposition-bietet-an-artikel": "ar3",
      },
    },
    {
      id: "anp5",
      titel: "Kaltasphalt 0/8, Eimer 30 kg",
      untertitel: "20 Stk à Fr. 64.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 2,
        bezeichnung: "Kaltasphalt 0/8, Eimer 30 kg",
        menge: 20,
        einheit: "Stk",
        einzelpreis: 64.0,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an3",
        "angebotsposition-bietet-an-artikel": "ar2",
      },
    },
    {
      id: "anp6",
      titel: "Rissverguss",
      untertitel: "140 lfm à Fr. 6.80",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 1,
        bezeichnung: "Rissverguss",
        menge: 140,
        einheit: "lfm",
        einzelpreis: 6.8,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an5",
        "angebotsposition-bietet-an-massnahmenart": "ma1",
      },
    },
    {
      id: "anp7",
      titel: "Signalisation und Verkehrsdienst",
      untertitel: "1 pauschal à Fr. 380.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 2,
        bezeichnung: "Signalisation und Verkehrsdienst",
        menge: 1,
        einheit: "pauschal",
        einzelpreis: 380.0,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an5",
      },
    },
    {
      id: "anp8",
      titel: "Kaltasphalt 0/8, Big Bag 1000 kg",
      untertitel: "12 Stk à Fr. 1180.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 1,
        bezeichnung: "Kaltasphalt 0/8, Big Bag 1000 kg",
        menge: 12,
        einheit: "Stk",
        einzelpreis: 1180.0,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an2",
        "angebotsposition-bietet-an-artikel": "ar3",
      },
    },
    {
      id: "anp10",
      titel: "Oberflächenbehandlung einfach",
      untertitel: "2400 m² à Fr. 9.80",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 1,
        bezeichnung: "Oberflächenbehandlung einfach",
        menge: 2400,
        einheit: "m²",
        einzelpreis: 9.8,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an4",
        "angebotsposition-bietet-an-massnahmenart": "ma4",
      },
    },
    {
      id: "anp11",
      titel: "Oberflächenbehandlung doppelt (oberer Abschnitt)",
      untertitel: "900 m² à Fr. 14.20",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 2,
        bezeichnung: "Oberflächenbehandlung doppelt (oberer Abschnitt)",
        menge: 900,
        einheit: "m²",
        einzelpreis: 14.2,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an4",
        "angebotsposition-bietet-an-massnahmenart": "ma5",
      },
    },
    {
      id: "anp12",
      titel: "Signalisation und Verkehrsdienst",
      untertitel: "1 pauschal à Fr. 380.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 3,
        bezeichnung: "Signalisation und Verkehrsdienst",
        menge: 1,
        einheit: "pauschal",
        einzelpreis: 380.0,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an4",
      },
    },
    {
      id: "anp9",
      titel: "Bitumenemulsion C69B4, IBC",
      untertitel: "2 Stk à Fr. 1450.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 2,
        bezeichnung: "Bitumenemulsion C69B4, IBC",
        menge: 2,
        einheit: "Stk",
        einzelpreis: 1450.0,
      },
      bezuege: {
        "angebotsposition-gehoert-zu-angebot": "an2",
        "angebotsposition-bietet-an-artikel": "ar4",
      },
    },
  ],
  ansprechpartner: [
    {
      id: "a1",
      titel: "Beat Zollinger",
      untertitel: "Leiter Werkhof",
      kennung: null,
      status: null,
      werte: {
        name: "Beat Zollinger",
        funktion: "Leiter Werkhof",
        telefon: "+41 71 913 41 11",
        eMail: "beat.zollinger@beispiel.ch",
      },
      bezuege: {
        "ansprechpartner-gehoert-zu-kunde": "k1",
      },
    },
    {
      id: "a2",
      titel: "Claudia Rüegg",
      untertitel: "Tiefbauamt",
      kennung: null,
      status: null,
      werte: {
        name: "Claudia Rüegg",
        funktion: "Tiefbauamt",
        telefon: "+41 71 913 42 12",
        eMail: "claudia.rueegg@beispiel.ch",
      },
      bezuege: {
        "ansprechpartner-gehoert-zu-kunde": "k2",
      },
    },
    {
      id: "a3",
      titel: "Stefan Ammann",
      untertitel: "Werkhof",
      kennung: null,
      status: null,
      werte: {
        name: "Stefan Ammann",
        funktion: "Werkhof",
        telefon: "+41 71 913 43 13",
        eMail: "stefan.ammann@beispiel.ch",
      },
      bezuege: {
        "ansprechpartner-gehoert-zu-kunde": "k3",
      },
    },
    {
      id: "a4",
      titel: "Martin Imhof",
      untertitel: "Bauverwalter",
      kennung: null,
      status: null,
      werte: {
        name: "Martin Imhof",
        funktion: "Bauverwalter",
        telefon: "+41 71 913 44 14",
        eMail: "martin.imhof@beispiel.ch",
      },
      bezuege: {
        "ansprechpartner-gehoert-zu-kunde": "k4",
      },
    },
    {
      id: "a5",
      titel: "Petra Meier",
      untertitel: "Einkauf",
      kennung: null,
      status: null,
      werte: {
        name: "Petra Meier",
        funktion: "Einkauf",
        telefon: "+41 71 913 45 15",
        eMail: "petra.meier@beispiel.ch",
      },
      bezuege: {
        "ansprechpartner-gehoert-zu-kunde": "k5",
      },
    },
    {
      id: "a6",
      titel: "Urs Bischof",
      untertitel: "Disposition",
      kennung: null,
      status: null,
      werte: {
        name: "Urs Bischof",
        funktion: "Disposition",
        telefon: "+41 71 913 46 16",
        eMail: "urs.bischof@beispiel.ch",
      },
      bezuege: {
        "ansprechpartner-gehoert-zu-kunde": "k6",
      },
    },
    {
      id: "a7",
      titel: "Andrea Gisler",
      untertitel: "Bauverwaltung",
      kennung: null,
      status: null,
      werte: {
        name: "Andrea Gisler",
        funktion: "Bauverwaltung",
        telefon: "+41 71 913 47 17",
        eMail: "andrea.gisler@beispiel.ch",
      },
      bezuege: {
        "ansprechpartner-gehoert-zu-kunde": "k7",
      },
    },
  ],
  verkaufschance: [
    {
      id: "vc1",
      titel: "Rissverguss Hauptstrasse Nord",
      untertitel: "Dienstleistung · Winter (Okt–Mär)",
      kennung: null,
      status: "Qualifiziert",
      werte: {
        bezeichnung: "Rissverguss Hauptstrasse Nord",
        geschaeftsbereich: "Dienstleistung",
        akquiseanlass: "Saisonimpuls",
        saisonfenster: "Winter (Okt–Mär)",
        geschaetztesVolumen: 1900,
      },
      bezuege: {
        "verkaufschance-betrifft-kunde": "k1",
        "verkaufschance-zugewiesen-an-mitarbeiter": "m1",
        "verkaufschance-betrifft-strassenobjekt": ["so1"],
      },
    },
    {
      id: "vc2",
      titel: "Randsteinfugen Zürcherstrasse 2027",
      untertitel: "Dienstleistung · Frühjahr (Apr–Mai)",
      kennung: null,
      status: "Identifiziert",
      werte: {
        bezeichnung: "Randsteinfugen Zürcherstrasse 2027",
        geschaeftsbereich: "Dienstleistung",
        akquiseanlass: "Kundenanfrage",
        saisonfenster: "Frühjahr (Apr–Mai)",
        geschaetztesVolumen: 9500,
      },
      bezuege: {
        "verkaufschance-betrifft-kunde": "k2",
        "verkaufschance-zugewiesen-an-mitarbeiter": "m1",
        "verkaufschance-betrifft-strassenobjekt": ["so2"],
      },
    },
    {
      id: "vc3",
      titel: "Kaltasphalt für den Werkhof",
      untertitel: "Baustoffhandel · Winter (Okt–Mär)",
      kennung: null,
      status: "Qualifiziert",
      werte: {
        bezeichnung: "Kaltasphalt für den Werkhof",
        geschaeftsbereich: "Baustoffhandel",
        akquiseanlass: "Cross-Selling",
        saisonfenster: "Winter (Okt–Mär)",
        geschaetztesVolumen: 4200,
        bedarfsbeschreibung:
          "Sursee bezieht Rissverguss als Leistung von Viacid, kauft Kaltasphalt für den Winterdienst aber beim Wettbewerb.",
      },
      bezuege: {
        "verkaufschance-betrifft-kunde": "k4",
        "verkaufschance-zugewiesen-an-mitarbeiter": "m1",
      },
    },
    {
      id: "vc4",
      titel: "Oberflächenbehandlung Winikon",
      untertitel: "Dienstleistung · Sommer (Jun–Sep)",
      kennung: null,
      status: "Qualifiziert",
      werte: {
        bezeichnung: "Oberflächenbehandlung Winikon",
        geschaeftsbereich: "Dienstleistung",
        akquiseanlass: "Saisonimpuls",
        saisonfenster: "Sommer (Jun–Sep)",
        geschaetztesVolumen: 48000,
      },
      bezuege: {
        "verkaufschance-betrifft-kunde": "k3",
        "verkaufschance-zugewiesen-an-mitarbeiter": "m2",
        "verkaufschance-betrifft-strassenobjekt": ["so3"],
      },
    },
    {
      id: "vc5",
      titel: "Rahmenvertrag Emulsion 2027",
      untertitel: "Baustoffhandel · Sommer (Jun–Sep)",
      kennung: null,
      status: "Gewonnen",
      werte: {
        bezeichnung: "Rahmenvertrag Emulsion 2027",
        geschaeftsbereich: "Baustoffhandel",
        akquiseanlass: "Bestandskunde",
        saisonfenster: "Sommer (Jun–Sep)",
        geschaetztesVolumen: 22000,
        entschiedenAm: "2026-09-19T14:00",
      },
      bezuege: {
        "verkaufschance-betrifft-kunde": "k5",
        "verkaufschance-zugewiesen-an-mitarbeiter": "m2",
      },
    },
    {
      id: "vc6",
      titel: "Schlaglochsanierung Klausenstrasse",
      untertitel: "Dienstleistung · Winter (Okt–Mär)",
      kennung: null,
      status: "Verloren",
      werte: {
        bezeichnung: "Schlaglochsanierung Klausenstrasse",
        geschaeftsbereich: "Dienstleistung",
        akquiseanlass: "Kundenanfrage",
        saisonfenster: "Winter (Okt–Mär)",
        geschaetztesVolumen: 6800,
        verlustgrund: "Preis",
        entschiedenAm: "2026-09-28T10:15",
      },
      bezuege: {
        "verkaufschance-betrifft-kunde": "k7",
        "verkaufschance-zugewiesen-an-mitarbeiter": "m1",
        "verkaufschance-betrifft-strassenobjekt": ["so6"],
      },
    },
  ],
  kundenkontakt: [
    {
      id: "kk1",
      titel: "Begehung Hauptstrasse Nord",
      untertitel: "Besuch · 2026-10-05",
      kennung: null,
      status: null,
      werte: {
        datum: "2026-10-05",
        kontaktart: "Besuch",
        anlass: "Begehung Hauptstrasse Nord",
        ergebnis:
          "Risse und drei Schlaglöcher aufgenommen; Angebot bis 16.10. zugesagt.",
      },
      bezuege: {
        "kundenkontakt-betrifft-kunde": "k1",
        "kundenkontakt-mit-ansprechpartner": "a1",
        "kundenkontakt-gefuehrt-von-mitarbeiter": "m1",
        "kundenkontakt-betrifft-verkaufschance": "vc1",
      },
    },
    {
      id: "kk2",
      titel: "Anfrage Randsteinfugen Zürcherstrasse",
      untertitel: "Telefon · 2026-10-08",
      kennung: null,
      status: null,
      werte: {
        datum: "2026-10-08",
        kontaktart: "Telefon",
        anlass: "Anfrage Randsteinfugen Zürcherstrasse",
        ergebnis:
          "Aufnahme vor Ort gemacht; Ausführung erst im Frühjahr möglich.",
      },
      bezuege: {
        "kundenkontakt-betrifft-kunde": "k2",
        "kundenkontakt-mit-ansprechpartner": "a2",
        "kundenkontakt-gefuehrt-von-mitarbeiter": "m1",
        "kundenkontakt-betrifft-verkaufschance": "vc2",
      },
    },
    {
      id: "kk3",
      titel: "Nachfrage Kaltasphalt Winterdienst",
      untertitel: "E-Mail · 2026-09-30",
      kennung: null,
      status: null,
      werte: {
        datum: "2026-09-30",
        kontaktart: "E-Mail",
        anlass: "Nachfrage Kaltasphalt Winterdienst",
        ergebnis: "Angebot über 4 Big Bags und 20 Eimer verschickt.",
      },
      bezuege: {
        "kundenkontakt-betrifft-kunde": "k4",
        "kundenkontakt-mit-ansprechpartner": "a4",
        "kundenkontakt-gefuehrt-von-mitarbeiter": "m1",
        "kundenkontakt-betrifft-verkaufschance": "vc3",
      },
    },
    {
      id: "kk4",
      titel: "Vorstellung Oberflächenbehandlung",
      untertitel: "Besuch · 2026-09-22",
      kennung: null,
      status: null,
      werte: {
        datum: "2026-09-22",
        kontaktart: "Besuch",
        anlass: "Vorstellung Oberflächenbehandlung",
        ergebnis:
          "Werkhof wünscht Variante mit doppelter Behandlung im oberen Abschnitt.",
      },
      bezuege: {
        "kundenkontakt-betrifft-kunde": "k3",
        "kundenkontakt-mit-ansprechpartner": "a3",
        "kundenkontakt-gefuehrt-von-mitarbeiter": "m2",
        "kundenkontakt-betrifft-verkaufschance": "vc4",
      },
    },
  ],
  aufgabe: [
    {
      id: "t1",
      titel: "Angebot Rissverguss Wil versenden",
      untertitel: "fällig 2026-10-16",
      kennung: null,
      status: "Offen",
      werte: {
        titel: "Angebot Rissverguss Wil versenden",
        aufgabenart: "Angebot",
        faelligAm: "2026-10-16",
        prioritaet: "Hoch",
      },
      bezuege: {
        "aufgabe-zugewiesen-an-mitarbeiter": "m1",
        "aufgabe-betrifft-kunde": "k1",
        "aufgabe-betrifft-angebot": "an1",
        "aufgabe-betrifft-verkaufschance": "vc1",
      },
    },
    {
      id: "t2",
      titel: "Angebot Kaltasphalt Sursee nachfassen",
      untertitel: "fällig 2026-10-14",
      kennung: null,
      status: "Offen",
      werte: {
        titel: "Angebot Kaltasphalt Sursee nachfassen",
        aufgabenart: "Wiedervorlage",
        faelligAm: "2026-10-14",
        prioritaet: "Mittel",
      },
      bezuege: {
        "aufgabe-zugewiesen-an-mitarbeiter": "m1",
        "aufgabe-betrifft-kunde": "k4",
        "aufgabe-betrifft-angebot": "an3",
        "aufgabe-betrifft-verkaufschance": "vc3",
      },
    },
    {
      id: "t3",
      titel: "Saisonimpuls Randsteinfugen an Kommunen",
      untertitel: "fällig 2026-11-30",
      kennung: null,
      status: "Offen",
      werte: {
        titel: "Saisonimpuls Randsteinfugen an Kommunen",
        aufgabenart: "Akquise",
        faelligAm: "2026-11-30",
        prioritaet: "Mittel",
      },
      bezuege: {
        "aufgabe-zugewiesen-an-mitarbeiter": "m2",
      },
    },
    {
      id: "t4",
      titel: "Rückruf Tiefbauamt Frauenfeld",
      untertitel: "fällig 2026-10-09",
      kennung: null,
      status: "Erledigt",
      werte: {
        titel: "Rückruf Tiefbauamt Frauenfeld",
        aufgabenart: "Rückruf",
        faelligAm: "2026-10-09",
        prioritaet: "Hoch",
      },
      bezuege: {
        "aufgabe-zugewiesen-an-mitarbeiter": "m1",
        "aufgabe-betrifft-kunde": "k2",
        "aufgabe-betrifft-verkaufschance": "vc2",
      },
    },
  ],
  bestellung: [
    {
      id: "bs1",
      titel: "Bestellung 4500231 · Baustoffe Ostschweiz AG",
      untertitel: "E-Mail mit PDF · 2026-10-02 08:14",
      kennung: null,
      status: "Geklärt",
      werte: {
        eingangsdatum: "2026-10-02T08:14",
        eingangskanal: "E-Mail mit PDF",
        kundenreferenz: "Bestellung 4500231",
        bestellinhalt:
          "12 Big Bag Kaltasphalt 0/8, 2 IBC Bitumenemulsion C69B4",
        gewuenschterLiefertermin: "2026-10-10",
        bestelldokument: "Bestellung.pdf",
      },
      bezuege: {
        "bestellung-von-kunde": "k6",
        "bestellung-bestellt-durch-ansprechpartner": "a6",
        "bestellung-bearbeitet-von-mitarbeiter": "m7",
        "bestellung-bestellt-artikel": ["ar3", "ar4"],
      },
    },
    {
      id: "bs2",
      titel: "WhatsApp-Bestellung · Strassenbau Meier AG",
      untertitel: "WhatsApp · 2026-10-11 19:42",
      kennung: null,
      status: "Eingegangen",
      werte: {
        eingangsdatum: "2026-10-11T19:42",
        eingangskanal: "WhatsApp",
        kundenreferenz: "–",
        bestellinhalt:
          "Nachbestellung 40 Eimer Rissvergussmasse, wenn möglich bis Freitag",
        gewuenschterLiefertermin: "2026-10-16",
      },
      bezuege: {
        "bestellung-von-kunde": "k5",
        "bestellung-bestellt-durch-ansprechpartner": "a5",
        "bestellung-bestellt-artikel": ["ar1"],
      },
    },
    {
      id: "bs3",
      titel: "EDI 4500240 · Baustoffe Ostschweiz AG",
      untertitel: "Kundensystem · 2026-10-09 06:30",
      kennung: null,
      status: "Geklärt",
      werte: {
        eingangsdatum: "2026-10-09T06:30",
        eingangskanal: "Kundensystem",
        kundenreferenz: "EDI 4500240",
        bestellinhalt: "60 Eimer Kaltasphalt 0/8",
        gewuenschterLiefertermin: "2026-10-15",
      },
      bezuege: {
        "bestellung-von-kunde": "k6",
        "bestellung-bestellt-durch-ansprechpartner": "a6",
        "bestellung-bearbeitet-von-mitarbeiter": "m7",
        "bestellung-bestellt-artikel": ["ar2"],
      },
    },
  ],
  auftrag: [
    {
      id: "au1",
      titel: "Rissverguss Industriestrasse",
      untertitel: "Gemeinde Wil · Dienstleistung",
      kennung: "AU-2026-0188",
      status: "Abrechnungsbereit",
      werte: {
        auftragsnummer: "AU-2026-0188",
        auftragsart: "Dienstleistung",
        auftragsdatum: "2026-09-19",
        ausfuehrungszeitraumVon: "2026-10-06",
        ausfuehrungszeitraumBis: "2026-10-07",
        abrechnungsbereitSeit: "2026-10-09T10:00",
      },
      bezuege: {
        "auftrag-von-kunde": "k1",
        "auftrag-ansprechpartner": "a1",
        "auftrag-betrifft-strassenobjekt": ["so5"],
        "auftrag-aus-angebot": "an5",
      },
    },
    {
      id: "au2",
      titel: "Baustofflieferung Baustoffe Ostschweiz AG",
      untertitel: "Baustoffe Ostschweiz AG · Handel",
      kennung: "AU-2026-0195",
      status: "Abgeschlossen",
      werte: {
        auftragsnummer: "AU-2026-0195",
        auftragsart: "Handel",
        auftragsdatum: "2026-10-03",
        liefertermin: "2026-10-10",
        versandart: "Spedition",
        abrechnungsbereitSeit: "2026-10-10T16:00",
      },
      bezuege: {
        "auftrag-von-kunde": "k6",
        "auftrag-ansprechpartner": "a6",
        "auftrag-aus-angebot": "an2",
        "auftrag-aus-bestellung": "bs1",
      },
    },
    {
      id: "au3",
      titel: "Baustofflieferung Baustoffe Ostschweiz AG",
      untertitel: "Baustoffe Ostschweiz AG · Handel",
      kennung: "AU-2026-0201",
      status: "Freigegeben",
      werte: {
        auftragsnummer: "AU-2026-0201",
        auftragsart: "Handel",
        auftragsdatum: "2026-10-09",
        liefertermin: "2026-10-15",
        versandart: "Spedition",
      },
      bezuege: {
        "auftrag-von-kunde": "k6",
        "auftrag-ansprechpartner": "a6",
        "auftrag-aus-bestellung": "bs3",
      },
    },
    {
      id: "au4",
      titel: "Randsteinfugen Zürcherstrasse",
      untertitel: "Stadt Frauenfeld · Dienstleistung",
      kennung: "AU-2026-0170",
      status: "Abgeschlossen",
      werte: {
        auftragsnummer: "AU-2026-0170",
        auftragsart: "Dienstleistung",
        auftragsdatum: "2026-08-28",
        ausfuehrungszeitraumVon: "2026-09-08",
        ausfuehrungszeitraumBis: "2026-09-09",
        abrechnungsbereitSeit: "2026-09-12T09:00",
      },
      bezuege: {
        "auftrag-von-kunde": "k2",
        "auftrag-ansprechpartner": "a2",
        "auftrag-betrifft-strassenobjekt": ["so2"],
      },
    },
    {
      id: "au5",
      titel: "Rissverguss Quartierstrassen Winikon",
      untertitel: "Gemeinde Uster · Dienstleistung",
      kennung: "AU-2026-0204",
      status: "Freigegeben",
      werte: {
        auftragsnummer: "AU-2026-0204",
        auftragsart: "Dienstleistung",
        auftragsdatum: "2026-10-10",
        ausfuehrungszeitraumVon: "2026-10-19",
        ausfuehrungszeitraumBis: "2026-10-21",
      },
      bezuege: {
        "auftrag-von-kunde": "k3",
        "auftrag-ansprechpartner": "a3",
        "auftrag-betrifft-strassenobjekt": ["so3"],
      },
    },
    {
      id: "au6",
      titel: "Baustofflieferung Strassenbau Meier AG",
      untertitel: "Strassenbau Meier AG · Handel",
      kennung: "AU-2026-0199",
      status: "Freigegeben",
      werte: {
        auftragsnummer: "AU-2026-0199",
        auftragsart: "Handel",
        auftragsdatum: "2026-10-07",
        liefertermin: "2026-10-14",
        versandart: "Spedition",
      },
      bezuege: {
        "auftrag-von-kunde": "k5",
        "auftrag-ansprechpartner": "a5",
      },
    },
  ],
  auftragsposition: [
    {
      id: "aup1",
      titel: "Rissverguss",
      untertitel: "140 lfm à Fr. 6.80",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 1,
        bezeichnung: "Rissverguss",
        menge: 140,
        einheit: "lfm",
        einzelpreis: 6.8,
        zusatzleistung: false,
      },
      bezuege: {
        "auftragsposition-gehoert-zu-auftrag": "au1",
        "auftragsposition-umfasst-massnahmenart": "ma1",
        "auftragsposition-uebernimmt-angebotsposition": "anp6",
      },
    },
    {
      id: "aup2",
      titel: "Signalisation und Verkehrsdienst",
      untertitel: "1 pauschal à Fr. 380.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 2,
        bezeichnung: "Signalisation und Verkehrsdienst",
        menge: 1,
        einheit: "pauschal",
        einzelpreis: 380.0,
        zusatzleistung: false,
      },
      bezuege: {
        "auftragsposition-gehoert-zu-auftrag": "au1",
        "auftragsposition-uebernimmt-angebotsposition": "anp7",
      },
    },
    {
      id: "aup3",
      titel: "Kaltasphalt 0/8, Big Bag 1000 kg",
      untertitel: "12 Stk à Fr. 1180.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 1,
        bezeichnung: "Kaltasphalt 0/8, Big Bag 1000 kg",
        menge: 12,
        einheit: "Stk",
        einzelpreis: 1180.0,
        zusatzleistung: false,
      },
      bezuege: {
        "auftragsposition-gehoert-zu-auftrag": "au2",
        "auftragsposition-umfasst-artikel": "ar3",
        "auftragsposition-uebernimmt-angebotsposition": "anp8",
      },
    },
    {
      id: "aup4",
      titel: "Bitumenemulsion C69B4, IBC",
      untertitel: "2 Stk à Fr. 1450.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 2,
        bezeichnung: "Bitumenemulsion C69B4, IBC",
        menge: 2,
        einheit: "Stk",
        einzelpreis: 1450.0,
        zusatzleistung: false,
      },
      bezuege: {
        "auftragsposition-gehoert-zu-auftrag": "au2",
        "auftragsposition-umfasst-artikel": "ar4",
        "auftragsposition-uebernimmt-angebotsposition": "anp9",
      },
    },
    {
      id: "aup5",
      titel: "Kaltasphalt 0/8, Eimer 30 kg",
      untertitel: "60 Stk à Fr. 64.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 1,
        bezeichnung: "Kaltasphalt 0/8, Eimer 30 kg",
        menge: 60,
        einheit: "Stk",
        einzelpreis: 64.0,
        zusatzleistung: false,
      },
      bezuege: {
        "auftragsposition-gehoert-zu-auftrag": "au3",
        "auftragsposition-umfasst-artikel": "ar2",
      },
    },
    {
      id: "aup6",
      titel: "Randsteinfugensanierung",
      untertitel: "210 lfm à Fr. 14.50",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 1,
        bezeichnung: "Randsteinfugensanierung",
        menge: 210,
        einheit: "lfm",
        einzelpreis: 14.5,
        zusatzleistung: false,
      },
      bezuege: {
        "auftragsposition-gehoert-zu-auftrag": "au4",
        "auftragsposition-umfasst-massnahmenart": "ma3",
      },
    },
    {
      id: "aup7",
      titel: "Rissverguss",
      untertitel: "520 lfm à Fr. 6.60",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 1,
        bezeichnung: "Rissverguss",
        menge: 520,
        einheit: "lfm",
        einzelpreis: 6.6,
        zusatzleistung: false,
      },
      bezuege: {
        "auftragsposition-gehoert-zu-auftrag": "au5",
        "auftragsposition-umfasst-massnahmenart": "ma1",
      },
    },
    {
      id: "aup8",
      titel: "Schlaglochreparatur Kaltasphalt",
      untertitel: "4 m² à Fr. 85.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 2,
        bezeichnung: "Schlaglochreparatur Kaltasphalt",
        menge: 4,
        einheit: "m²",
        einzelpreis: 85.0,
        zusatzleistung: true,
      },
      bezuege: {
        "auftragsposition-gehoert-zu-auftrag": "au5",
        "auftragsposition-umfasst-massnahmenart": "ma2",
      },
    },
    {
      id: "aup9",
      titel: "Rissvergussmasse heiss, Eimer 25 kg",
      untertitel: "40 Stk à Fr. 118.00",
      kennung: null,
      status: null,
      werte: {
        positionsnummer: 1,
        bezeichnung: "Rissvergussmasse heiss, Eimer 25 kg",
        menge: 40,
        einheit: "Stk",
        einzelpreis: 118.0,
        zusatzleistung: false,
      },
      bezuege: {
        "auftragsposition-gehoert-zu-auftrag": "au6",
        "auftragsposition-umfasst-artikel": "ar1",
      },
    },
  ],
  lieferung: [
    {
      id: "li1",
      titel: "Lieferung LS-2026-0884",
      untertitel: "Spedition · 2026-10-10",
      kennung: "LS-2026-0884",
      status: "Zugestellt",
      werte: {
        lieferscheinnummer: "LS-2026-0884",
        liefertermin: "2026-10-10",
        versandart: "Spedition",
        anzahlPackstuecke: 14,
        transportdienstleister: "Galliker Transport",
        empfangenVon: "U. Bischof",
        angeliefertAm: "2026-10-10T10:45",
        empfangsquittung: "Quittung.pdf",
        sendungsnummer: "GAL08840421",
      },
      bezuege: {
        "lieferung-zu-auftrag": "au2",
      },
    },
    {
      id: "li2",
      titel: "Lieferung LS-2026-0902",
      untertitel: "Spedition · 2026-10-15",
      kennung: "LS-2026-0902",
      status: "Veranlasst",
      werte: {
        lieferscheinnummer: "LS-2026-0902",
        liefertermin: "2026-10-15",
        versandart: "Spedition",
        anzahlPackstuecke: 3,
        transportdienstleister: "Galliker Transport",
      },
      bezuege: {
        "lieferung-zu-auftrag": "au3",
      },
    },
    {
      id: "li3",
      titel: "Lieferung LS-2026-0897",
      untertitel: "Spedition · 2026-10-14",
      kennung: "LS-2026-0897",
      status: "Versendet",
      werte: {
        lieferscheinnummer: "LS-2026-0897",
        liefertermin: "2026-10-14",
        versandart: "Spedition",
        anzahlPackstuecke: 2,
        transportdienstleister: "Galliker Transport",
        sendungsnummer: "GAL08970421",
      },
      bezuege: {
        "lieferung-zu-auftrag": "au6",
      },
    },
  ],
  rechnung: [
    {
      id: "re1",
      titel: "Rechnung RE-2026-0611",
      untertitel: "Stadt Frauenfeld · Fr. 3'639.75",
      kennung: "RE-2026-0611",
      status: "Bezahlt",
      werte: {
        rechnungsnummer: "RE-2026-0611",
        bexioRechnungsnummer: "1088",
        rechnungsdatum: "2026-09-12",
        faelligkeitsdatum: "2026-10-12",
        betragNetto: 3367.0,
        betragBrutto: 3639.75,
        mahnstufe: 0,
        versendetAm: "2026-09-12T16:00",
        rechnungsdokument: "RE-2026-0611.pdf",
        bezahlterBetrag: 3639.75,
        bezahltAm: "2026-10-02",
      },
      bezuege: {
        "rechnung-zu-auftrag": "au4",
        "rechnung-an-kunde": "k2",
      },
    },
    {
      id: "re2",
      titel: "Rechnung RE-2026-0655",
      untertitel: "Baustoffe Ostschweiz AG · Fr. 18'441.85",
      kennung: "RE-2026-0655",
      status: "Versendet",
      werte: {
        rechnungsnummer: "RE-2026-0655",
        bexioRechnungsnummer: "1131",
        rechnungsdatum: "2026-10-10",
        faelligkeitsdatum: "2026-11-09",
        betragNetto: 17060.0,
        betragBrutto: 18441.85,
        mahnstufe: 0,
        versendetAm: "2026-10-10T16:00",
        rechnungsdokument: "RE-2026-0655.pdf",
      },
      bezuege: {
        "rechnung-zu-auftrag": "au2",
        "rechnung-an-kunde": "k6",
      },
    },
  ],
  fahrzeug: [
    {
      id: "f1",
      titel: "Spritzfahrzeug Rissverguss",
      untertitel: "Spezialfahrzeug",
      kennung: "SG 412 778",
      status: null,
      werte: {
        bezeichnung: "Spritzfahrzeug Rissverguss",
        kennzeichen: "SG 412 778",
        fahrzeugart: "Spezialfahrzeug",
        stundenkostensatz: 145,
      },
      bezuege: {},
    },
    {
      id: "f2",
      titel: "LKW 3-Achser mit Splittstreuer",
      untertitel: "LKW",
      kennung: "SG 389 102",
      status: null,
      werte: {
        bezeichnung: "LKW 3-Achser mit Splittstreuer",
        kennzeichen: "SG 389 102",
        fahrzeugart: "LKW",
        stundenkostensatz: 120,
      },
      bezuege: {},
    },
    {
      id: "f3",
      titel: "Lieferwagen Iveco Daily",
      untertitel: "Lieferwagen",
      kennung: "SG 556 201",
      status: null,
      werte: {
        bezeichnung: "Lieferwagen Iveco Daily",
        kennzeichen: "SG 556 201",
        fahrzeugart: "Lieferwagen",
        stundenkostensatz: 45,
      },
      bezuege: {},
    },
    {
      id: "f4",
      titel: "Tandemwalze 2.5 t",
      untertitel: "Maschine",
      kennung: "–",
      status: null,
      werte: {
        bezeichnung: "Tandemwalze 2.5 t",
        kennzeichen: "–",
        fahrzeugart: "Maschine",
        stundenkostensatz: 65,
      },
      bezuege: {},
    },
    {
      id: "f5",
      titel: "Kompressor mit Heissluftlanze",
      untertitel: "Maschine",
      kennung: "–",
      status: null,
      werte: {
        bezeichnung: "Kompressor mit Heissluftlanze",
        kennzeichen: "–",
        fahrzeugart: "Maschine",
        stundenkostensatz: 30,
      },
      bezuege: {},
    },
  ],
  abwesenheit: [
    {
      id: "ab1",
      titel: "Ferien Pascal Wyss",
      untertitel: "2026-10-19 – 2026-10-23",
      kennung: null,
      status: "Bestätigt",
      werte: {
        von: "2026-10-19",
        bis: "2026-10-23",
        abwesenheitsart: "Ferien",
        tagesanteil: "Ganztag",
        gemeldetAm: "2026-10-01T08:00",
      },
      bezuege: {
        "abwesenheit-betrifft-mitarbeiter": "m6",
      },
    },
    {
      id: "ab2",
      titel: "Krankheit Daniel Huber",
      untertitel: "2026-10-12 – 2026-10-13",
      kennung: null,
      status: "Gemeldet",
      werte: {
        von: "2026-10-12",
        bis: "2026-10-13",
        abwesenheitsart: "Krankheit",
        tagesanteil: "Ganztag",
        gemeldetAm: "2026-10-01T08:00",
      },
      bezuege: {
        "abwesenheit-betrifft-mitarbeiter": "m5",
      },
    },
    {
      id: "ab3",
      titel: "Weiterbildung Luca Steiner",
      untertitel: "2026-11-04 – 2026-11-04",
      kennung: null,
      status: "Gemeldet",
      werte: {
        von: "2026-11-04",
        bis: "2026-11-04",
        abwesenheitsart: "Weiterbildung",
        tagesanteil: "Vormittag",
        gemeldetAm: "2026-10-01T08:00",
      },
      bezuege: {
        "abwesenheit-betrifft-mitarbeiter": "m4",
      },
    },
  ],
  einsatz: [
    {
      id: "e1",
      titel: "Vormittag · Rissverguss Industriestrasse",
      untertitel: "2026-10-06 · Vormittag",
      kennung: null,
      status: "Ausgeführt",
      werte: {
        einsatzdatum: "2026-10-06",
        zeitslot: "Vormittag",
        bodentemperatur: 7.5,
        lufttemperatur: 9.0,
        luftfeuchtigkeit: 72,
        oberflaecheTrocken: true,
        oberflaecheSauber: true,
        geprueftAm: "2026-10-06T07:20",
      },
      bezuege: {
        "einsatz-fuer-auftrag": "au1",
        "einsatz-am-strassenobjekt": "so5",
        "einsatz-team": ["m4", "m5", "m6"],
        "einsatz-gefuehrt-von-mitarbeiter": "m4",
        "einsatz-nutzt-fahrzeug": ["f1", "f3"],
      },
    },
    {
      id: "e2",
      titel: "Vormittag · Rissverguss Industriestrasse",
      untertitel: "2026-10-07 · Vormittag",
      kennung: null,
      status: "Ausgeführt",
      werte: {
        einsatzdatum: "2026-10-07",
        zeitslot: "Vormittag",
        bodentemperatur: 6.0,
        lufttemperatur: 8.5,
        luftfeuchtigkeit: 75,
        oberflaecheTrocken: true,
        oberflaecheSauber: true,
        geprueftAm: "2026-10-07T07:20",
      },
      bezuege: {
        "einsatz-fuer-auftrag": "au1",
        "einsatz-am-strassenobjekt": "so5",
        "einsatz-team": ["m4", "m5"],
        "einsatz-gefuehrt-von-mitarbeiter": "m4",
        "einsatz-nutzt-fahrzeug": ["f1"],
      },
    },
    {
      id: "e3",
      titel: "Ganztag · Randsteinfugen Zürcherstrasse",
      untertitel: "2026-09-08 · Ganztag",
      kennung: null,
      status: "Ausgeführt",
      werte: {
        einsatzdatum: "2026-09-08",
        zeitslot: "Ganztag",
        bodentemperatur: 12.0,
        lufttemperatur: 15.5,
        luftfeuchtigkeit: 60,
        oberflaecheTrocken: true,
        oberflaecheSauber: true,
        geprueftAm: "2026-09-08T07:20",
      },
      bezuege: {
        "einsatz-fuer-auftrag": "au4",
        "einsatz-am-strassenobjekt": "so2",
        "einsatz-team": ["m4", "m5", "m6"],
        "einsatz-gefuehrt-von-mitarbeiter": "m4",
        "einsatz-nutzt-fahrzeug": ["f1", "f3"],
      },
    },
    {
      id: "e4",
      titel: "Vormittag · Rissverguss Quartierstrassen Winikon",
      untertitel: "2026-10-14 · Vormittag",
      kennung: null,
      status: "Ausführung abgesagt",
      werte: {
        einsatzdatum: "2026-10-14",
        zeitslot: "Vormittag",
        bodentemperatur: 2.5,
        lufttemperatur: 4.0,
        luftfeuchtigkeit: 91,
        oberflaecheTrocken: false,
        oberflaecheSauber: true,
        geprueftAm: "2026-10-14T07:20",
        begruendungAusfuehrungsentscheidung:
          "Bodentemperatur unter 5 °C, Oberfläche feucht.",
      },
      bezuege: {
        "einsatz-fuer-auftrag": "au5",
        "einsatz-am-strassenobjekt": "so3",
        "einsatz-team": ["m4", "m6"],
        "einsatz-gefuehrt-von-mitarbeiter": "m4",
        "einsatz-nutzt-fahrzeug": ["f1"],
      },
    },
    {
      id: "e5",
      titel: "Vormittag · Rissverguss Quartierstrassen Winikon",
      untertitel: "2026-10-19 · Vormittag",
      kennung: null,
      status: "Terminiert",
      werte: {
        einsatzdatum: "2026-10-19",
        zeitslot: "Vormittag",
      },
      bezuege: {
        "einsatz-fuer-auftrag": "au5",
        "einsatz-am-strassenobjekt": "so3",
        "einsatz-team": ["m4", "m5"],
        "einsatz-gefuehrt-von-mitarbeiter": "m4",
        "einsatz-nutzt-fahrzeug": ["f1", "f3"],
      },
    },
    {
      id: "e6",
      titel: "Nachmittag · Rissverguss Quartierstrassen Winikon",
      untertitel: "2026-10-19 · Nachmittag",
      kennung: null,
      status: "Terminiert",
      werte: {
        einsatzdatum: "2026-10-19",
        zeitslot: "Nachmittag",
      },
      bezuege: {
        "einsatz-fuer-auftrag": "au5",
        "einsatz-am-strassenobjekt": "so3",
        "einsatz-team": ["m4", "m5"],
        "einsatz-gefuehrt-von-mitarbeiter": "m4",
        "einsatz-nutzt-fahrzeug": ["f1", "f3"],
      },
    },
    {
      id: "e7",
      titel: "Vormittag · Rissverguss Quartierstrassen Winikon",
      untertitel: "2026-10-20 · Vormittag",
      kennung: null,
      status: "Geplant",
      werte: {
        einsatzdatum: "2026-10-20",
        zeitslot: "Vormittag",
      },
      bezuege: {
        "einsatz-fuer-auftrag": "au5",
        "einsatz-am-strassenobjekt": "so3",
      },
    },
  ],
  arbeitsrapport: [
    {
      id: "rp1",
      titel: "Rapport RA-2026-1041",
      untertitel: "2026-10-06",
      kennung: "RA-2026-1041",
      status: "Abgeschlossen",
      werte: {
        rapportnummer: "RA-2026-1041",
        rapportdatum: "2026-10-06",
        bindemittelDosierung: 0.47,
        anfahrtszeit: 0.75,
      },
      bezuege: {
        "arbeitsrapport-zu-einsatz": "e1",
      },
    },
    {
      id: "rp2",
      titel: "Rapport RA-2026-1046",
      untertitel: "2026-10-07",
      kennung: "RA-2026-1046",
      status: "Abgeschlossen",
      werte: {
        rapportnummer: "RA-2026-1046",
        rapportdatum: "2026-10-07",
        bindemittelDosierung: 0.44,
        anfahrtszeit: 0.75,
      },
      bezuege: {
        "arbeitsrapport-zu-einsatz": "e2",
      },
    },
    {
      id: "rp3",
      titel: "Rapport RA-2026-0987",
      untertitel: "2026-09-08",
      kennung: "RA-2026-0987",
      status: "Abgeschlossen",
      werte: {
        rapportnummer: "RA-2026-0987",
        rapportdatum: "2026-09-08",
        bindemittelDosierung: 0.92,
        anfahrtszeit: 0.75,
      },
      bezuege: {
        "arbeitsrapport-zu-einsatz": "e3",
      },
    },
  ],
  rapportzeile: [
    {
      id: "rz1",
      titel: "Arbeitszeit · 4.0 h",
      untertitel: "2026-10-06",
      kennung: null,
      status: null,
      werte: {
        zeilenart: "Arbeitszeit",
        beginn: "2026-10-06T07:00",
        ende: "2026-10-06T11:30",
        pause: 0.5,
        stunden: 4.0,
      },
      bezuege: {
        "rapportzeile-zu-einsatz": "e1",
        "rapportzeile-gehoert-zu-arbeitsrapport": "rp1",
        "rapportzeile-von-mitarbeiter": "m4",
      },
    },
    {
      id: "rz2",
      titel: "Arbeitszeit · 4.0 h",
      untertitel: "2026-10-06",
      kennung: null,
      status: null,
      werte: {
        zeilenart: "Arbeitszeit",
        beginn: "2026-10-06T07:00",
        ende: "2026-10-06T11:30",
        pause: 0.5,
        stunden: 4.0,
      },
      bezuege: {
        "rapportzeile-zu-einsatz": "e1",
        "rapportzeile-gehoert-zu-arbeitsrapport": "rp1",
        "rapportzeile-von-mitarbeiter": "m5",
      },
    },
    {
      id: "rz3",
      titel: "Arbeitszeit · 4.0 h",
      untertitel: "2026-10-06",
      kennung: null,
      status: null,
      werte: {
        zeilenart: "Arbeitszeit",
        beginn: "2026-10-06T07:00",
        ende: "2026-10-06T11:30",
        pause: 0.5,
        stunden: 4.0,
      },
      bezuege: {
        "rapportzeile-zu-einsatz": "e1",
        "rapportzeile-gehoert-zu-arbeitsrapport": "rp1",
        "rapportzeile-von-mitarbeiter": "m6",
      },
    },
    {
      id: "rz4",
      titel: "Fahrzeugzeit · 3.5 h",
      untertitel: "2026-10-06",
      kennung: null,
      status: null,
      werte: {
        zeilenart: "Fahrzeugzeit",
        beginn: "2026-10-06T07:15",
        ende: "2026-10-06T10:45",
        pause: 0.5,
        stunden: 3.5,
      },
      bezuege: {
        "rapportzeile-zu-einsatz": "e1",
        "rapportzeile-gehoert-zu-arbeitsrapport": "rp1",
        "rapportzeile-fuer-fahrzeug": "f1",
      },
    },
    {
      id: "rz5",
      titel: "Ausgeführte Menge · 85 lfm",
      untertitel: "",
      kennung: null,
      status: null,
      werte: {
        zeilenart: "Ausgeführte Menge",
        gemeldeteMenge: 85,
      },
      bezuege: {
        "rapportzeile-zu-einsatz": "e1",
        "rapportzeile-gehoert-zu-arbeitsrapport": "rp1",
        "rapportzeile-von-mitarbeiter": "m4",
      },
    },
    {
      id: "rz6",
      titel: "Arbeitszeit · 3.0 h",
      untertitel: "2026-10-07",
      kennung: null,
      status: null,
      werte: {
        zeilenart: "Arbeitszeit",
        beginn: "2026-10-07T07:00",
        ende: "2026-10-07T10:30",
        pause: 0.5,
        stunden: 3.0,
      },
      bezuege: {
        "rapportzeile-zu-einsatz": "e2",
        "rapportzeile-gehoert-zu-arbeitsrapport": "rp2",
        "rapportzeile-von-mitarbeiter": "m4",
      },
    },
    {
      id: "rz7",
      titel: "Ausgeführte Menge · 55 lfm",
      untertitel: "",
      kennung: null,
      status: null,
      werte: {
        zeilenart: "Ausgeführte Menge",
        gemeldeteMenge: 55,
      },
      bezuege: {
        "rapportzeile-zu-einsatz": "e2",
        "rapportzeile-gehoert-zu-arbeitsrapport": "rp2",
        "rapportzeile-von-mitarbeiter": "m4",
      },
    },
  ],
  ausmassprotokoll: [
    {
      id: "amprot1",
      titel: "Ausmaß AM-2026-0091",
      untertitel: "2026-10-07",
      kennung: "AM-2026-0091",
      status: "Freigegeben",
      werte: {
        protokollnummer: "AM-2026-0091",
        ausmassdatum: "2026-10-07",
        freigegebenAm: "2026-10-09T09:40",
        freigabedokument: "Ausmass-signiert.pdf",
      },
      bezuege: {
        "ausmassprotokoll-zu-auftrag": "au1",
      },
    },
    {
      id: "amprot2",
      titel: "Ausmaß AM-2026-0084",
      untertitel: "2026-09-09",
      kennung: "AM-2026-0084",
      status: "Freigegeben",
      werte: {
        protokollnummer: "AM-2026-0084",
        ausmassdatum: "2026-09-09",
        freigegebenAm: "2026-09-11T14:10",
        freigabedokument: "Ausmass-signiert.pdf",
      },
      bezuege: {
        "ausmassprotokoll-zu-auftrag": "au4",
      },
    },
  ],
  ausmassposition: [
    {
      id: "amp1",
      titel: "Rissverguss",
      untertitel: "140 lfm",
      kennung: null,
      status: null,
      werte: {
        bezeichnung: "Rissverguss",
        ausgefuehrteMenge: 140,
        einheit: "lfm",
        nachweis: "Rapporte RA-2026-1041 und RA-2026-1046",
      },
      bezuege: {
        "ausmassposition-gehoert-zu-ausmassprotokoll": "amprot1",
        "ausmassposition-misst-auftragsposition": "aup1",
      },
    },
    {
      id: "amp2",
      titel: "Signalisation und Verkehrsdienst",
      untertitel: "1 pauschal",
      kennung: null,
      status: null,
      werte: {
        bezeichnung: "Signalisation und Verkehrsdienst",
        ausgefuehrteMenge: 1,
        einheit: "pauschal",
        nachweis: "–",
      },
      bezuege: {
        "ausmassposition-gehoert-zu-ausmassprotokoll": "amprot1",
        "ausmassposition-misst-auftragsposition": "aup2",
      },
    },
    {
      id: "amp3",
      titel: "Randsteinfugensanierung",
      untertitel: "206 lfm",
      kennung: null,
      status: null,
      werte: {
        bezeichnung: "Randsteinfugensanierung",
        ausgefuehrteMenge: 206,
        einheit: "lfm",
        nachweis: "Rapport RA-2026-0987",
      },
      bezuege: {
        "ausmassposition-gehoert-zu-ausmassprotokoll": "amprot2",
        "ausmassposition-misst-auftragsposition": "aup6",
      },
    },
  ],
  materialbewegung: [
    {
      id: "mb1",
      titel: "Entnahme · 10 Eimer Rissvergussmasse",
      untertitel: "2026-10-06 06:30",
      kennung: null,
      status: "Bestätigt",
      werte: {
        bewegungsart: "Entnahme",
        menge: 10,
        einheit: "Eimer",
        zeitpunkt: "2026-10-06T06:30",
        bemerkung: "Aus Lager geladen",
      },
      bezuege: {
        "materialbewegung-betrifft-artikel": "ar1",
        "materialbewegung-fuer-einsatz": "e1",
        "materialbewegung-fuer-auftrag": "au1",
        "materialbewegung-gemeldet-von-mitarbeiter": "m4",
      },
    },
    {
      id: "mb2",
      titel: "Verbrauch · 8 Eimer Rissvergussmasse",
      untertitel: "2026-10-07 11:00",
      kennung: null,
      status: "Bestätigt",
      werte: {
        bewegungsart: "Verbrauch",
        menge: 8,
        einheit: "Eimer",
        zeitpunkt: "2026-10-07T11:00",
      },
      bezuege: {
        "materialbewegung-betrifft-artikel": "ar1",
        "materialbewegung-fuer-einsatz": "e2",
        "materialbewegung-fuer-auftrag": "au1",
        "materialbewegung-gemeldet-von-mitarbeiter": "m4",
      },
    },
    {
      id: "mb3",
      titel: "Rückgabe · 2 Eimer Rissvergussmasse",
      untertitel: "2026-10-07 13:15",
      kennung: null,
      status: "Gemeldet",
      werte: {
        bewegungsart: "Rückgabe",
        menge: 2,
        einheit: "Eimer",
        zeitpunkt: "2026-10-07T13:15",
        bemerkung: "Zwei volle Eimer zurück ins Lager",
      },
      bezuege: {
        "materialbewegung-betrifft-artikel": "ar1",
        "materialbewegung-fuer-auftrag": "au1",
        "materialbewegung-gemeldet-von-mitarbeiter": "m8",
      },
    },
    {
      id: "mb4",
      titel: "Auslieferung · 12 Big Bag Kaltasphalt",
      untertitel: "2026-10-10 07:00",
      kennung: null,
      status: "Bestätigt",
      werte: {
        bewegungsart: "Auslieferung",
        menge: 12,
        einheit: "Big Bag",
        zeitpunkt: "2026-10-10T07:00",
      },
      bezuege: {
        "materialbewegung-betrifft-artikel": "ar3",
        "materialbewegung-fuer-lieferung": "li1",
        "materialbewegung-fuer-auftrag": "au2",
        "materialbewegung-gemeldet-von-mitarbeiter": "m8",
      },
    },
    {
      id: "mb5",
      titel: "Auslieferung · 2 IBC Bitumenemulsion",
      untertitel: "2026-10-10 07:00",
      kennung: null,
      status: "Bestätigt",
      werte: {
        bewegungsart: "Auslieferung",
        menge: 2,
        einheit: "IBC",
        zeitpunkt: "2026-10-10T07:00",
      },
      bezuege: {
        "materialbewegung-betrifft-artikel": "ar4",
        "materialbewegung-fuer-lieferung": "li1",
        "materialbewegung-fuer-auftrag": "au2",
        "materialbewegung-gemeldet-von-mitarbeiter": "m8",
      },
    },
  ],
  nachkalkulation: [
    {
      id: "nk1",
      titel: "Nachkalkulation Randsteinfugen Zürcherstrasse",
      untertitel: "Stichtag 2026-10-05",
      kennung: null,
      status: "Bewertet",
      werte: {
        stichtag: "2026-10-05",
        sonstigeKosten: 120,
        beurteilung: "Deckungsbeitrag 38 %, Vorgabe erreicht.",
        abweichungsursachen:
          "4 lfm weniger ausgeführt als beauftragt; Materialverbrauch 6 % über Ansatz.",
        konsequenzenFuerAngebote:
          "Fugenansatz bei offenen Fugen über 10 mm auf 1.0 kg/lfm erhöhen.",
        bewertetAm: "2026-10-05T15:00",
      },
      bezuege: {
        "nachkalkulation-zu-auftrag": "au4",
      },
    },
  ],
  reklamation: [
    {
      id: "rk1",
      titel: "Fuge bei Nr. 140 wieder offen",
      untertitel: "Stadt Frauenfeld · 2026-10-08",
      kennung: null,
      status: "Gemeldet",
      werte: {
        eingangsdatum: "2026-10-08",
        meldekanal: "E-Mail",
        mangelbeschreibung:
          "Nach starkem Regen ist die Fuge bei Zürcherstrasse 140 auf rund 3 m wieder offen.",
      },
      bezuege: {
        "reklamation-von-kunde": "k2",
        "reklamation-zu-auftrag": "au4",
        "reklamation-betrifft-strassenobjekt": "so2",
        "reklamation-bearbeitet-von-mitarbeiter": "m4",
      },
    },
  ],
};
